// de — checkin/quickCheck/stepTracker blocks translated.
export const de = {
  "common": {
    "loading": "Wird geladen...",
    "save": "Speichern",
    "cancel": "Abbrechen",
    "delete": "Löschen",
    "edit": "Bearbeiten",
    "close": "Schließen",
    "confirm": "Bestätigen",
    "back": "Zurück",
    "next": "Weiter",
    "submit": "Absenden",
    "search": "Suchen",
    "select": "Auswählen",
    "or": "Oder",
    "and": "und",
    "note": "Hinweis",
    "viewAll": "Alle anzeigen",
    "learnMore": "Mehr erfahren",
    "getStarted": "Jetzt loslegen",
    "continue": "Weiter",
    "saving": "Wird gespeichert..."
  },
  "nav": {
    "dashboard": "Home",
    "nutrition": "Ernährung",
    "family": "Familie",
    "care": "Dienste",
    "careShort": "Dienste",
    "checkIn": "Check-In",
    "insights": "Erkenntnisse",
    "trends": "Trends",
    "habits": "Gewohnheiten",
    "medications": "Medikamente",
    "expertSupport": "Experten-Support",
    "profile": "Profil",
    "healthHub": "Health Hub",
    "support": "Support",
    "wellness": "Wellness",
    "education": "Wissen",
    "community": "Community",
    "preventiveHealth": "Vorsorge",
    "womensHealth": "Frauengesundheit",
    "reminders": "Erinnerungen",
    "meals": "Mahlzeiten",
    "orders": "Bestellungen",
    "subscription": "Abonnement",
    "logout": "Abmelden"
  },

  "navShort": {
    "dashboard": "Start",
    "nutrition": "Ernährung",
    "family": "Familie",
    "care": "Dienste",
    "support": "Hilfe",
    "profile": "Profil"
  },
  "auth": {
    "login": "Anmelden",
    "register": "Konto erstellen",
    "logout": "Abmelden",
    "email": "E-Mail",
    "password": "Passwort",
    "name": "Vollständiger Name",
    "forgotPassword": "Passwort vergessen?",
    "noAccount": "Sie haben noch kein Konto?",
    "haveAccount": "Sie haben bereits ein Konto?",
    "signInHere": "Hier anmelden",
    "signUpHere": "Hier registrieren",
    "welcomeBack": "Willkommen zurück!",
    "getStarted": "Legen wir los",
    "biometricLogin": "Biometrische Anmeldung",
    "biometricHelper": "Verwenden Sie Fingerabdruck, Face ID oder Windows Hello",
    "vendorLogin": "Anbieter-Login",
    "createOne": "Konto erstellen",
    "tagline": "Ihrer Gesundheit einen Schritt voraus – mit einem einfachen täglichen Check.",
    "takes30s": "Dauert weniger als 30 Sekunden",
    "emailPlaceholder": "ihre-email@beispiel.de",
    "passwordPlaceholder": "Passwort eingeben",
    "checking": "Wird geprüft...",
    "continue": "Weiter",
    "secureMessage": "Sicher und privat – Ihre Daten bleiben geschützt",
    "biometricSoon": "Biometrischer Login – Demnächst verfügbar",
    "sessionExpired": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an, um dort fortzufahren, wo Sie aufgehört haben.",
    "showPassword": "Passwort anzeigen",
    "hidePassword": "Passwort verbergen",
    "vendor": {
      "title": "Partner-Login für Händler",
      "subtitle": "Greifen Sie auf Ihr HealthLoop-Händler-Dashboard zu",
      "businessEmail": "Geschäftliche E-Mail",
      "emailPlaceholder": "haendler@unternehmen.de",
      "passwordPlaceholder": "••••••••",
      "signingIn": "Anmeldung läuft...",
      "signIn": "Anmelden",
      "notVendorYet": "Noch kein Partner-Händler?",
      "registerBusiness": "Registrieren Sie Ihr Unternehmen",
      "areYouUser": "Sind Sie Nutzer?",
      "userLogin": "Nutzer-Login",
      "welcomeBackToast": "Willkommen zurück!",
      "genericError": "Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut."
    },
    "admin": {
      "backToUserLogin": "Nutzer-Anmeldung",
      "title": "Admin-Anmeldung",
      "restrictedBadge": "Eingeschränkt",
      "tagline": "HealthLoop-Konsole – Administrator-Zugangsdaten erforderlich.",
      "emailLabel": "Admin-E-Mail",
      "emailPlaceholder": "admin@ihredomain.de",
      "passwordLabel": "Passwort",
      "passwordPlaceholder": "Geben Sie Ihr Admin-Passwort ein",
      "signingIn": "Anmeldung läuft...",
      "submit": "Bei Admin-Konsole anmelden",
      "secureNote": "Sichere Verbindung · Sitzung verschlüsselt",
      "restrictedTitle": "Dieser Bereich ist Administratoren vorbehalten.",
      "restrictedBody": "Sie sind angemeldet, verfügen jedoch nicht über Admin-Rechte. Melden Sie sich ab, um ein anderes Konto zu nutzen, oder kehren Sie zur Haupt-App zurück.",
      "signOut": "Abmelden",
      "backToApp": "Zurück zur App"
    }
  },
  "quickCheck": {
    "header": {
      "title": "Wie fühlst du dich heute?",
      "subtitle": "Kurzer Check – dauert weniger als 60 Sekunden"
    },
    "section1": {
      "title": "Was bemerkst du heute?",
      "hint": "(Wähle alles aus, was zutrifft)"
    },
    "environment": {
      "title": "Deine Umgebung heute",
      "hint": "Hilf uns, dein Umfeld zu verstehen"
    },
    "basicChecks": {
      "title": "Kurze Basis-Checks",
      "hint": "Optional, aber hilfreich"
    },
    "validation": {
      "pickOne": "Bitte beantworte mindestens eine Frage"
    },
    "submit": {
      "cta": "Meinen Gesundheits-Einblick erhalten",
      "saving": "Wird gespeichert...",
      "analyzing": "Deine Gesundheitsmuster werden analysiert...",
      "savedToast": "✅ Check-In gespeichert! Deine Muster werden analysiert..."
    }
  },
  "stepTracker": {
    "header": {
      "title": "Schrittzähler",
      "subtitle": "Ehrliche Aktivitätsmessung, direkt auf deinem Gerät",
      "backToDashboard": "Zurück zum Dashboard"
    },
    "today": {
      "title": "Heutige Schritte",
      "goalProgress": "{{current}} / {{goal}} Schritte",
      "goalReached": "Ziel erreicht – super Arbeit!",
      "keepGoing": "Bleib dran – du bist auf einem guten Weg."
    },
    "streak": {
      "label": "Aktuelle Serie",
      "days": "{{count}} Tag",
      "daysPlural": "{{count}} Tage"
    },
    "badges": {
      "title": "Abzeichen",
      "empty": "Du verdienst dir Abzeichen, während du die Gewohnheit festigst."
    },
    "reminders": {
      "title": "Bewegungs-Impulse",
      "hint": "Sanfte Erinnerungen an kurze Spaziergänge bei langem Sitzen.",
      "enabled": "Aktiviert",
      "disabled": "Deaktiviert"
    },
    "insights": {
      "weeklyAverage": "Wöchentlicher Durchschnitt",
      "weeklyGoal": "Wochenziel"
    },
    "actions": {
      "connect": "Schrittquelle verbinden",
      "manualLog": "Schritte manuell eintragen",
      "changeGoal": "Tagesziel ändern"
    }
  },
  "checkin": {
    "header": {
      "title": "Täglicher Gesundheits-Check-In",
      "subtitle": "Dauert weniger als 60 Sekunden",
      "restDayLink": "Mir ist heute nicht danach"
    },
    "snapshot": {
      "title": "Dein aktualisiertes Dashboard",
      "healthScore": "Gesundheits-Score",
      "todayTasks": "Heutige Aufgaben",
      "dayStreak": "Tage in Folge"
    },
    "resume": {
      "banner": "Dort fortgesetzt, wo du aufgehört hast",
      "startFresh": "Neu starten",
      "dismiss": "Verwerfen"
    },
    "progress": {
      "allSet": "Alles bereit",
      "step": "Schritt {{current}} von {{total}}",
      "ariaLabel": "Fortschritt des täglichen Check-Ins: {{done}} von {{total}} Abschnitten abgeschlossen"
    },
    "insights": {
      "title": "Deine Gesundheits-Einblicke",
      "subtitle": "Heute ganz persönlich für dich",
      "insightForYou": "Einblick für dich",
      "simpleActions": "Einfache Schritte für dich",
      "whenToSeekHelp": "Wann du Unterstützung suchen solltest",
      "nhsAdvice": "Bei Bedenken kontaktiere bitte deinen Hausarzt oder den ärztlichen Notdienst",
      "backToDashboard": "Zurück zum Dashboard",
      "newCheckIn": "Neuer Check-In",
      "disclaimer": "HealthLoop bietet Orientierungshilfe, keine medizinische Diagnose."
    },
    "restDay": {
      "title": "Ruhe gehört zum Rhythmus.",
      "body": "Wir sind morgen wieder für dich da.",
      "streakNote": "Deine Serie wurde nicht unterbrochen – sie ruht sich nur auch aus.",
      "backToDashboard": "Zurück zum Dashboard",
      "changedMind": "Eigentlich möchte ich doch einchecken."
    },
    "feelings": {
      "title": "Wie fühlst du dich heute?",
      "hint": "Wähle alles aus, was zutrifft",
      "tired": "Müde",
      "headache": "Kopfschmerzen",
      "stressed": "Gestresst oder überfordert",
      "pain": "Körperschmerzen",
      "okay": "Ich fühle mich heute gut"
    },
    "basics": {
      "title": "Deine Grundlagen",
      "sleepQ": "Hast du letzte Nacht gut geschlafen?",
      "waterQ": "Hast du heute genug Wasser getrunken?",
      "foodQ": "Hast du heute ausgewogen gegessen?",
      "activityQ": "Wie aktiv warst du heute?",
      "yes": "Ja",
      "notReally": "Nicht wirklich",
      "notYet": "Noch nicht",
      "notActive": "Nicht aktiv",
      "lightActivity": "Leicht aktiv",
      "active": "Aktiv"
    },
    "mind": {
      "title": "Geist & Energie",
      "stressQ": "Wie hoch ist dein Stresslevel heute?",
      "moodQ": "Wie ist deine Stimmung heute?",
      "energyQ": "Wie ist dein Energielevel heute?",
      "low": "Niedrig",
      "moderate": "Mäßig",
      "high": "Hoch",
      "neutral": "Neutral",
      "good": "Gut",
      "okay": "Ganz gut"
    },
    "day": {
      "title": "Dein Tag",
      "routineQ": "Bist du heute deiner gewohnten Routine gefolgt?",
      "yes": "Ja",
      "no": "Nein"
    },
    "environment": {
      "title": "Deine Umgebung heute",
      "describeQ": "Wie würdest du deine Umgebung beschreiben?",
      "comfortable": "😊 Angenehm",
      "slightlyUncomfortable": "😐 Etwas unangenehm",
      "challenging": "😓 Belastend",
      "affectedQ": "Hat dein Umfeld beeinflusst, wie du dich fühlst?",
      "yes": "Ja",
      "no": "Nein",
      "exposureLabel": "Einflüsse (alles auswählen, was zutrifft)",
      "heat": "🌡️ Hitze",
      "cold": "❄️ Kälte",
      "noise": "🔊 Lärm",
      "dustSmoke": "💨 Staub oder Rauch",
      "crowded": "👥 Menschenmengen",
      "none": "✅ Keine"
    },
    "submit": {
      "analyzing": "Deine Gesundheitsmuster werden analysiert...",
      "cta": "Meine Gesundheits-Einblicke ansehen"
    },
    "toast": {
      "savedFull": "Check-In gespeichert! Dein Dashboard wurde aktualisiert.",
      "savedShort": "Check-In gespeichert."
    }
  },
  "onboarding": {
    "welcome": "Willkommen",
    "completeSetup": "Einrichtung abschließen",
    "stepProgress": "Schritt {{step}} von {{total}}",
    "percentComplete": "{{percent}}% abgeschlossen",
    "welcomeToast": "Willkommen bei HealthLoop! Ihr Profil wurde erstellt.",
    "errorAgeRange": "Bitte wählen Sie Ihre Altersgruppe aus",
    "errorCountry": "Bitte wählen Sie Ihr Land aus",
    "errorGoal": "Bitte wählen Sie Ihr primäres Gesundheitsziel aus",
    "errorCuisine": "Bitte wählen Sie mindestens eine bevorzugte Küche aus",
    "errorGeneric": "Einrichtung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "step1Title": "Willkommen bei HealthLoop! 👋",
    "step1Subtitle": "Lassen Sie uns Ihre Gesundheitsreise personalisieren",
    "ageRangeLabel": "In welcher Altersgruppe befinden Sie sich?",
    "genderLabel": "Geschlecht (Optional)",
    "gender_male": "Männlich",
    "gender_female": "Weiblich",
    "gender_non-binary": "Nicht-binär",
    "gender_prefer_not_to_say": "Keine Angabe",
    "step2Title": "Wo wohnen Sie? 🌍",
    "step2Subtitle": "Dies hilft uns, passende Mahlzeiten zu empfehlen",
    "countryLabel": "Wählen Sie Ihr Land",
    "country_uk": "Großbritannien",
    "country_nigeria": "Nigeria",
    "country_ghana": "Ghana",
    "country_kenya": "Kenia",
    "country_south_africa": "Südafrika",
    "country_usa": "USA",
    "country_canada": "Kanada",
    "country_india": "Indien",
    "country_jamaica": "Jamaika",
    "country_other": "Andere",
    "step3Title": "Was ist Ihr Hauptziel? 🎯",
    "step3Subtitle": "Wählen Sie Ihr wichtigstes Gesundheitsziel",
    "additionalGoals": "Weitere Ziele? (Optional)",
    "goal_weight_loss": "Gewichtsabnahme",
    "goalDesc_weight_loss": "Gesund Gewicht verlieren",
    "goal_weight_maintenance": "Gewicht halten",
    "goalDesc_weight_maintenance": "Aktuelles Gewicht beibehalten",
    "goal_muscle_gain": "Muskelaufbau",
    "goalDesc_muscle_gain": "Kraft und Muskeln aufbauen",
    "goal_general_wellness": "Allgemeines Wohlbefinden",
    "goalDesc_general_wellness": "Die allgemeine Gesundheit fördern",
    "goal_better_sleep": "Besser schlafen",
    "goalDesc_better_sleep": "Die Schlafqualität verbessern",
    "goal_reduce_stress": "Stress reduzieren",
    "goalDesc_reduce_stress": "Stress besser bewältigen",
    "goal_increase_energy": "Mehr Energie",
    "goalDesc_increase_energy": "Sich vitaler fühlen",
    "step4Title": "Ernährungspräferenzen 🍽️",
    "step4Subtitle": "Wählen Sie Küchen, die Sie mögen, und eventuelle Einschränkungen",
    "cuisineLabel": "Bevorzugte Küchen",
    "cuisineHint": "Wählen Sie mindestens eine (Mehrfachauswahl möglich)",
    "dietaryLabel": "Ernährungseinschränkungen (Optional)",
    "diet_vegetarian": "Vegetarisch",
    "diet_vegan": "Vegan",
    "diet_halal": "Halal",
    "diet_kosher": "Koscher",
    "diet_gluten_free": "Glutenfrei",
    "diet_dairy_free": "Laktosefrei",
    "diet_pescatarian": "Pescetarisch",
    "step5Title": "Gesundheitszustand 🏥",
    "step5Subtitle": "Optional – hilft uns bei besseren Empfehlungen",
    "conditionsLabel": "Liegt einer der folgenden Zustände vor?",
    "conditionsHint": "Diese Informationen sind privat und dienen der Personalisierung",
    "condition_diabetes": "Diabetes",
    "condition_hypertension": "Bluthochdruck",
    "condition_heart_disease": "Herzerkrankung",
    "condition_thyroid": "Schilddrüsenprobleme",
    "condition_celiac": "Zöliakie",
    "condition_ibs": "Reizdarmsyndrom",
    "condition_none": "Keine",
    "privacyTitle": "Ihre Daten sind geschützt",
    "privacyBody": "Ihre persönlichen Daten werden verschlüsselt und sicher gespeichert. Wir nutzen diese Daten ausschließlich zur Personalisierung Ihres Erlebnisses durch maßgeschneiderte Mahlzeitenpläne, Tipps zum Wohlbefinden und Benachrichtigungen. Ihre Daten werden niemals ohne Ihre ausdrückliche Zustimmung an Dritte weitergegeben.",
    "trackMedication": "Ich möchte meine Medikamente tracken",
    "specialistInterest": "Ich interessiere mich für Fachberatungen",
    "welcomeTitle": "Willkommen bei HealthLoop! 👋",
    "welcomeSubtitle": "Lassen Sie uns Ihre KI-gestützte Präventions- und Lifestyle-Intelligenz in wenigen einfachen Schritten personalisieren",
    "stepLabel": "Schritt {{current}} von {{total}}",
    "skipForNow": "Vorerst überspringen",
    "skipToast": "Sie können das Onboarding jederzeit in Ihrem Profil abschließen",
    "back": "Zurück",
    "next": "Weiter",
    "completing": "Wird abgeschlossen...",
    "complete": "Setup abschließen",
    "successToast": "Willkommen bei HealthLoop! Ihr Profil ist jetzt personalisiert 🎉",
    "failureToast": "Onboarding konnte nicht abgeschlossen werden",
    "validation": {
      "basicInfo": "Bitte füllen Sie alle Basisinformationen aus",
      "pickGoal": "Bitte wählen Sie mindestens ein Wellness-Ziel aus",
      "pickPrimary": "Bitte wählen Sie Ihr Hauptziel aus",
      "pickRegion": "Bitte wählen Sie Ihre kulturelle Region für personalisierte Menüvorschläge aus",
      "pickFocus": "Bitte wählen Sie Ihren Hauptfokus für Ihr Wohlbefinden aus"
    },
    "step1": {
      "title": "Ihr Gesundheitsprofil",
      "description": "Helfen Sie uns, Ihre personalisierte KI-Wellness-Intelligenz aufzubauen",
      "age": "Alter *",
      "agePlaceholder": "z. B. 30",
      "height": "Größe (cm) *",
      "heightPlaceholder": "z. B. 170",
      "weight": "Gewicht (kg) *",
      "weightPlaceholder": "z. B. 70"
    },
    "step2": {
      "title": "Ihre Wellness-Ziele",
      "description": "Wählen Sie alles Zutreffende aus und bestimmen Sie dann Ihr Hauptziel",
      "primaryLabel": "Wählen Sie Ihr Hauptziel *",
      "primaryBadge": "Hauptziel"
    },
    "step3": {
      "title": "🌍 Kultur & Essensvorlieben",
      "description": "Helfen Sie uns, Ihre Mahlzeitenempfehlungen zu personalisieren",
      "regionLabel": "Kulturelle Region *",
      "regionHint": "Wählen Sie Ihren kulturellen Hintergrund für passende Mahlzeitenvorschläge",
      "countryLabel": "Land (Optional)",
      "countryPlaceholder": "z. B. Nigeria, Kenia, Jamaika",
      "countryHint": "Für noch individuellere Empfehlungen",
      "foodPrefLabel": "Präferenz für Vielfalt"
    },
    "step4": {
      "title": "Hauptfokus Wohlbefinden",
      "description": "Wählen Sie den Bereich, auf den Sie sich am meisten konzentrieren möchten"
    },
    "step5": {
      "title": "Ihre Einstellungen",
      "description": "Passen Sie Ihr HealthLoop-Erlebnis an",
      "trackMeds": "Medikation erfassen",
      "trackMedsHint": "Aktivieren Sie die Erfassung und Erinnerungen in Ihren täglichen Check-ins",
      "specialist": "Interesse an Experten-Unterstützung",
      "specialistHint": "Erhalten Sie Zugang zu Wellness-Spezialisten, Ernährungsberatern und Mentaltrainern",
      "confidentialTitle": "Vertrauliche Unterstützung:",
      "confidentialBody": "Alle Ihre Informationen sind geschützt und werden ausschließlich dazu verwendet, Ihnen personalisierte Einblicke in die Gesundheitsvorsorge zu geben."
    },
    "step6": {
      "title": "Personalisierung der Mahlzeiten",
      "description": "Helfen Sie uns, Mahlzeiten zu empfehlen, die Ihrem Geschmack und Ihren Bedürfnissen entsprechen",
      "cuisinesLabel": "Bevorzugte Küchen (Optional)",
      "cuisinesHint": "Wählen Sie die Küchen, die Sie am liebsten mögen",
      "dietaryLabel": "Besondere Ernährungsweise (Optional)",
      "dietaryHint": "Wählen Sie alles aus, was auf Sie zutrifft",
      "allergiesLabel": "Häufige Allergien (Optional)",
      "allergiesHint": "Wählen Sie bestehende Lebensmittelallergien aus",
      "personalisedTitle": "Personalisierte Mahlzeiten:",
      "personalisedBody": "Wir nutzen diese Vorlieben, um Mahlzeiten zu empfehlen, die Ihrem Geschmack entsprechen. Sie können dies später jederzeit in den Einstellungen ändern."
    },
    "healthGoals": {
      "better_sleep": "Besser schlafen",
      "reduce_stress": "Stress abbauen",
      "increase_energy": "Energie steigern",
      "weight_management": "Gewichtsmanagement",
      "improve_fitness": "Fitness verbessern",
      "better_nutrition": "Bessere Ernährung",
      "mental_wellness": "Mentales Wohlbefinden",
      "chronic_condition": "Zustand managen"
    },
    "wellnessFocus": {
      "mental_health": {
        "label": "Mentale Gesundheit",
        "description": "Fokus auf Stimmung, Stress und emotionales Wohlbefinden"
      },
      "physical_fitness": {
        "label": "Physische Fitness",
        "description": "Fokus auf Bewegung, Kraft und Aktivität"
      },
      "nutrition": {
        "label": "Ernährung",
        "description": "Fokus auf Diät, Mahlzeiten und gesundes Essen"
      },
      "sleep": {
        "label": "Schlafqualität",
        "description": "Fokus auf Ruhe, Schlafmuster und Erholung"
      },
      "stress_management": {
        "label": "Stressmanagement",
        "description": "Fokus auf Entspannung und Stressreduzierung"
      }
    },
    "culturalRegions": {
      "west_african": {
        "label": "Westafrikanisch",
        "description": "Nigerianische, ghanaische, senegalesische Küche"
      },
      "east_african": {
        "label": "Ostafrikanisch",
        "description": "Kenianische, äthiopische, tansanische Küche"
      },
      "north_african": {
        "label": "Nordafrikanisch",
        "description": "Marokkanische, ägyptische Küche"
      },
      "southern_african": {
        "label": "Südafrikanisch",
        "description": "Südafrikanische Küche"
      },
      "caribbean": {
        "label": "Karibisch",
        "description": "Jamaikanische, trinidadische, barbadische Küche"
      },
      "middle_eastern": {
        "label": "Nahöstlich",
        "description": "Libanesische, palästinensische, syrische Küche"
      },
      "south_asian": {
        "label": "Südasiatisch",
        "description": "Indische, pakistanische, bangladeschische Küche"
      },
      "east_asian": {
        "label": "Ostasiatisch",
        "description": "Chinesische, japanische, koreanische Küche"
      },
      "southeast_asian": {
        "label": "Südostasiatisch",
        "description": "Thailändische, vietnamesische, indonesische Küche"
      },
      "western": {
        "label": "Westlich",
        "description": "Amerikanische, europäische Küche"
      },
      "latin_american": {
        "label": "Lateinamerikanisch",
        "description": "Mexikanische, brasilianische, argentinische Küche"
      },
      "mediterranean": {
        "label": "Mediterran",
        "description": "Griechische, italienische, spanische Küche"
      }
    },
    "foodPreferences": {
      "traditional": {
        "label": "Traditionell",
        "description": "Hauptsächlich Mahlzeiten aus Ihrer kulturellen Region"
      },
      "mixed": {
        "label": "Gemischt",
        "description": "Balance zwischen lokaler und internationaler Küche"
      },
      "international": {
        "label": "International",
        "description": "Vielfältige globale Küchen"
      }
    },
    "cuisines": {
      "west_african": "Westafrikanisch",
      "caribbean": "Karibisch",
      "mediterranean": "Mediterran",
      "asian": "Asiatisch",
      "western": "Westlich",
      "indian": "Indisch",
      "middle_eastern": "Nahöstlich",
      "general": "Alle Küchen"
    },
    "dietary": {
      "vegetarian": "Vegetarisch",
      "vegan": "Vegan",
      "pescatarian": "Pescetarisch",
      "gluten_free": "Glutenfrei",
      "dairy_free": "Laktosefrei",
      "low_carb": "Low-Carb"
    },
    "allergies": {
      "nuts": "Nüsse",
      "shellfish": "Schalentiere",
      "dairy": "Milchprodukte",
      "eggs": "Eier",
      "soy": "Soja",
      "gluten": "Gluten"
    },
    "cuisine_nigerian": "Nigerianisch",
    "cuisine_ghanaian": "Ghanaisch",
    "cuisine_senegalese": "Senegalesisch",
    "cuisine_kenyan": "Kenianisch",
    "cuisine_ethiopian": "Äthiopisch",
    "cuisine_moroccan": "Marokkanisch",
    "cuisine_south_african": "Südafrikanisch",
    "cuisine_jamaican": "Jamaikanisch",
    "cuisine_trinidadian": "Trinidadisch",
    "cuisine_lebanese": "Libanesisch",
    "cuisine_turkish": "Türkisch",
    "cuisine_greek": "Griechisch",
    "cuisine_italian": "Italienisch",
    "cuisine_french": "Französisch",
    "cuisine_british": "Britisch",
    "cuisine_indian_south": "Südindisch",
    "cuisine_indian_north": "Nordindisch",
    "cuisine_pakistani": "Pakistanisch",
    "cuisine_japanese": "Japanisch",
    "cuisine_chinese": "Chinesisch",
    "cuisine_korean": "Koreanisch",
    "cuisine_vietnamese": "Vietnamesisch",
    "cuisine_thai": "Thailändisch",
    "cuisine_filipino": "Philippinisch",
    "cuisine_american": "Amerikanisch",
    "cuisine_mexican": "Mexikanisch",
    "cuisine_brazilian": "Brasilianisch",
    "cuisine_peruvian": "Peruanisch"
  },
  "dashboard": {
    "welcome": "Willkommen zurück",
    "greeting": "Hallo",
    "goodMorning": "Guten Morgen",
    "goodAfternoon": "Guten Tag",
    "goodEvening": "Guten Abend",
    "tagline": "Kleine gesunde Schritte bewirken dauerhafte Veränderung",
    "microcopy": "Ihr Weg zum Wohlbefinden zählt.",
    "welcomeSubtitleMorning1": "Ein ruhiger Start in den Tag.",
    "welcomeSubtitleMorning2": "Schön, dass Sie heute Morgen vorbeischauen.",
    "welcomeSubtitleMorning3": "Kleine Momente summieren sich.",
    "welcomeSubtitleAfternoon1": "Wir hoffen, Ihr Tag verläuft stabil.",
    "welcomeSubtitleAfternoon2": "Willkommen zurück bei HealthLoop.",
    "welcomeSubtitleAfternoon3": "Atmen Sie tief durch – Sie machen das gut.",
    "welcomeSubtitleEvening1": "Gemeinsam den Tag ausklingen lassen.",
    "welcomeSubtitleEvening2": "Ein sanfter Abschluss des Tages.",
    "welcomeSubtitleEvening3": "Willkommen zurück an diesem Abend.",
    "title": "Ihre Plattform für Gesundheitsvorsorge",
    "subtitle": "Tracken, lernen und handeln, bevor Probleme entstehen",
    "summary": "Zusammenfassung Ihres Wohlbefindens",
    "summaryDesc": "Echtzeit-Erkenntnisse zu Vorsorge, Wissen, Engagement und Wellness",
    "comprehensiveSupport": "Umfassende Unterstützung in den Bereichen Prävention, Bildung und Wellness",
    "todayCheckIn": "Heutiger Check-In",
    "quickActions": "Schnellzugriff",
    "healthOverview": "Gesundheitsübersicht",
    "recentActivity": "Letzte Aktivitäten",
    "viewAll": "Alle anzeigen",
    "preventiveHealth": "Vorsorge",
    "preventiveHealthDesc": "Tägliches Tracking, Wellness-Monitoring & Vorsorge-Hinweise",
    "education": "Wissen",
    "educationDesc": "Evidenzbasierte Erkenntnisse, Fachartikel & Expertenrat",
    "engagement": "Engagement",
    "engagementDesc": "Community-Challenges, Gewohnheits-Tracking & Austausch",
    "wellness": "Wellness",
    "wellnessDesc": "Smarte Ernährung, Lifestyle-Balance & ganzheitliches Wohlbefinden",
    "todaysInsight": "Heutige Erkenntnis",
    "wellnessScore": "Wellness-Score",
    "healthStreak": "Gesundheits-Serie",
    "days": "Tage",
    "logHealth": "Wohlbefinden loggen",
    "getEducated": "Wissen vertiefen",
    "communityChallenge": "Community-Challenge",
    "checkWellness": "Wellness prüfen",
    "verified": "Verifiziert",
    "joinCommunity": "Community beitreten",
    "personalizedPlan": "Persönlicher Plan",
    "score": "Score",
    "checkIns": "Check-Ins",
    "habits": "Gewohnheiten",
    "preventive": "Vorsorge",
    "healthMetrics": "Gesundheitswerte",
    "trackMetrics": "Werte tracken",
    "startTracking": "Tracking starten",
    "logMetrics": "Werte eintragen",
    "dailyInsight": "Tägliche Erkenntnis",
    "learnAbout": "Erfahren Sie heute mehr über Vorsorge",
    "articlesAvailable": "Artikel verfügbar",
    "browseArticles": "Artikel durchsuchen",
    "currentStreak": "Aktuelle Serie",
    "keepGoing": "Weiter so!",
    "startStreak": "Serie starten",
    "checkIn": "Einchecken",
    "nutritionPlan": "Ernährungsplan",
    "mealsPlanned": "geplante Mahlzeiten",
    "viewPlan": "Plan ansehen",
    "planYourWeek": "Woche planen",
    "moodStress": "Stimmung & Stress",
    "howFeeling": "Wie fühlen Sie sich?",
    "logWellness": "Wellness loggen",
    "medications": "Medikamente",
    "noMeds": "Keine Medikamente erfasst",
    "addMedications": "Medikamente hinzufügen",
    "daysTracked": "Tage getrackt",
    "noHabits": "Noch keine Gewohnheiten",
    "startTrackingHabits": "Gewohnheiten tracken",
    "insights": "Erkenntnisse",
    "noInsights": "Noch keine Erkenntnisse",
    "completeFirstPlan": "Ersten Plan abschließen",
    "noCheckIns": "Noch keine Check-Ins",
    "startFirstCheckIn": "Ersten Check-In starten"
  },
  "support": {
    "title": "Support",
    "subtitle": "Antworten finden, Kontakt aufnehmen oder Problem melden",
    "backToSettings": "Zurück zu Einstellungen",
    "privacyBanner": "Support-Anfragen werden privat und sicher behandelt. Ihre Gesundheitsdaten bleiben vertraulich.",
    "section1": "Abschnitt 1",
    "section2": "Abschnitt 2",
    "section3": "Abschnitt 3",
    "section4": "Abschnitt 4",
    "navHelpCenter": "Hilfebereich",
    "navContact": "Support kontaktieren",
    "navHealth": "Gesundheitsdienste",
    "navTechnical": "Technischer Support",
    "helpCenterTitle": "Hilfebereich",
    "helpCenterSubtitle": "Häufige Fragen durchsuchen und schnelle Antworten finden.",
    "contactTitle": "Support kontaktieren",
    "contactSubtitle": "Erreichen Sie unser Team über Ihren bevorzugten Kanal.",
    "healthServicesTitle": "Gesundheitsdienste",
    "healthServicesSubtitle": "Verbindung zu Medikamenten-Tracking und klinischen Experten.",
    "technicalTitle": "Technischer Support",
    "technicalSubtitle": "Fehler oder technische Probleme detailliert melden.",
    "searchPlaceholder": "Häufige Fragen suchen...",
    "liveChat": "Live-Chat",
    "emailUs": "E-Mail schreiben",
    "callBack": "Rückruf vereinbaren",
    "sendMessage": "Nachricht senden",
    "medicationTracking": "Medikamenten-Tracking",
    "specialistAccess": "Zugang zu Experten",
    "videoConsultation": "Videosprechstunde",
    "reportBug": "Fehler melden",
    "yourName": "Ihr Name",
    "yourEmail": "Ihre E-Mail",
    "subject": "Betreff",
    "message": "Nachricht",
    "phone": "Telefon",
    "description": "Beschreibung",
    "submit": "Absenden",
    "successTitle": "Nachricht gesendet",
    "successDescription": "Wir antworten Ihnen innerhalb von 24–48 Stunden.",
    "healthDisclaimer": "Bei medizinischen Notfällen wenden Sie sich bitte an den Notruf. HealthLoop ist kein Ersatz für professionelle medizinische Versorgung."
  },
  "nutrition": {
    "smartNutrition": "Smarte Ernährung",
    "basedOnGoal": "Basierend auf Ihrem Ziel:",
    "personalizedData": "Personalisiert basierend auf Ihren aktuellen Daten",
    "evidenceBased": "Evidenzbasierte Ernährung als Teil Ihres Vorsorgeplans",
    "todaysMealSuggestions": "Heutige Vorschläge",
    "customize": "Anpassen",
    "breakfast": "Frühstück",
    "lunch": "Mittagessen",
    "dinner": "Abendessen",
    "loadingBreakfast": "Frühstück wird geladen...",
    "loadingLunch": "Mittagessen wird geladen...",
    "loadingDinner": "Abendessen wird geladen...",
    "cal": "kcal",
    "protein": "Eiweiß",
    "swapMeal": "Mahlzeit tauschen",
    "healthyOptionsNearYou": "Gesunde Optionen in der Nähe",
    "enableLocation": "Standort aktivieren",
    "view": "Ansehen",
    "discoverOptions": "Entdecken Sie gesunde Restaurants, Märkte und Lieferdienste in Ihrer Nähe",
    "cuisinesSelected": "Küchen ausgewählt",
    "cuisineSelected": "Küche ausgewählt",
    "dietaryPrefs": "Ernährungsweisen",
    "dietaryPref": "Ernährungsweise",
    "customizeMeals": "Mahlzeiten anpassen",
    "subtitleAdaptive": "Kulturell angepasste, persönliche Mahlzeitenplanung für Ihre Ziele",
    "hideFavorites": "Favoriten ausblenden",
    "viewFavorites": "Favoriten anzeigen",
    "customizeMealsLegacy": "Passen Sie Mahlzeiten an Ihre Vorlieben und Bedürfnisse an",
    "viewFullPlan": "Ganzen Plan ansehen",
    "exploreRecipes": "Rezepte entdecken"
  },
  "location": {
    "permissionTitle": "Gesunde Optionen in der Nähe finden",
    "permissionDesc": "Wird verwendet, um Restaurants und Märkte zu empfehlen, die zu Ihren Gesundheitszielen passen.",
    "howToEnable": "So aktivieren Sie es:",
    "step1": "Klicken Sie auf das Schloss-Symbol 🔒 in der Adressleiste",
    "step2": "Suchen Sie nach „Standort“-Berechtigungen",
    "step3": "Ändern Sie die Einstellung auf „Zulassen“",
    "step4": "Laden Sie diese Seite neu",
    "refreshPage": "Seite neu laden",
    "allowLocation": "Standort zulassen",
    "notNow": "Nicht jetzt",
    "denied": "Standortzugriff wurde blockiert. Um Optionen in der Nähe zu sehen, aktivieren Sie bitte die Berechtigungen.",
    "unavailable": "Standortinformationen sind derzeit nicht verfügbar. Bitte prüfen Sie Ihre Geräte-Einstellungen.",
    "error": "Zugriff auf den Standort nicht möglich. Bitte versuchen Sie es erneut.",
    "unsupported": "Ihr Browser unterstützt keine Standortdienste. Nutzen Sie einen modernen Browser wie Chrome, Firefox oder Safari.",
    "accessRequired": "Standortzugriff erforderlich"
  },
  "womensHealth": {
    "title": "Frauengesundheit",
    "description": "Tracken Sie Ihren Zyklus, loggen Sie Symptome und erhalten Sie Tipps passend zu Ihrer Zyklusphase",
    "cycleTracking": "Zyklus-Tracking",
    "symptomLogging": "Symptom-Log",
    "phaseInsights": "Phasen-Erkenntnisse",
    "logPeriod": "Periode eintragen",
    "logSymptoms": "Symptome loggen",
    "insights": "Erkenntnisse",
    "tips": "Wellness-Tipps",
    "overview": "Übersicht",
    "history": "Verlauf",
    "startTracking": "Zyklus-Tracking starten"
  },
  "profile": {
    "title": "Profil",
    "personalInfo": "Persönliche Informationen",
    "healthProfile": "Gesundheitsprofil",
    "preferences": "Einstellungen",
    "language": "Sprache",
    "selectLanguage": "Sprache wählen",
    "notifications": "Benachrichtigungen",
    "privacy": "Datenschutz",
    "security": "Sicherheit",
    "quickAccess": "Schnellzugriff",
    "editProfile": "Profil bearbeiten",
    "viewStats": "Statistiken ansehen",
    "backToDashboard": "Zurück zum Dashboard",
    "womensHealthTitle": "Frauengesundheit",
    "womensHealthDesc": "Zyklus-Tracking, Symptome & Tipps",
    "healthRemindersTitle": "Gesundheits-Erinnerungen",
    "healthRemindersDesc": "Benachrichtigungen verwalten",
    "manageRemindersDesc": "Verwalten Sie Ihre Erinnerungen und Mitteilungen",
    "healthPatternAlerts": "Hinweise zu Gesundheitsmustern",
    "supportHelp": "Support & Hilfe",
    "supportHelpDesc": "Unterstützung erhalten oder FAQs lesen",
    "admin": "Admin",
    "adminDesc": "Nutzungsmetriken und Einblicke ansehen",
    "giveFeedback": "Feedback geben",
    "giveFeedbackDesc": "Teilen Sie Ihre Erfahrungen mit HealthLoop",
    "reportProblem": "Problem melden",
    "reportProblemDesc": "Helfen Sie uns, Fehler zu beheben",
    "manageHealthInfo": "Verwalten Sie Ihre Vorsorge-Informationen für persönliche Erkenntnisse",
    "basicInformation": "Basis-Informationen",
    "fullName": "Vollständiger Name",
    "email": "E-Mail",
    "dateOfBirth": "Geburtsdatum",
    "gender": "Geschlecht",
    "height": "Größe (cm)",
    "weight": "Gewicht (kg)",
    "medicalConditions": "Zustände/Erkrankungen",
    "allergies": "Allergien",
    "personalHealth": "Persönliche Gesundheit",
    "addCondition": "Zustand hinzufügen",
    "addAllergy": "Allergie hinzufügen",
    "saveChanges": "Änderungen speichern",
    "saving": "Wird gespeichert...",
    "privacyMessage": "Ihre Gesundheitsdaten sind durch vertrauliche Sorgfaltsstandards geschützt"
  },
  "settings": {
    "title": "Einstellungen",
    "general": "Allgemein",
    "account": "Konto",
    "appearance": "Erscheinungsbild",
    "languageSettings": "Spracheinstellungen",
    "changeLanguage": "Sprache ändern",
    "languageNote": "Die Benutzeroberfläche aktualisiert sich sofort, wenn Sie eine neue Sprache auswählen. Afrikanische und neu hinzugefügte Sprachen sind als 'Starter' gekennzeichnet – maschinell übersetzt für eine größere Reichweite, die Überprüfung durch Muttersprachler steht noch aus.",
    "languageUpdated": "Sprache erfolgreich aktualisiert",
    "starterBadge": "Starter",
    "starterBadgeTooltip": "Maschinell übersetzt – Überprüfung durch Muttersprachler steht aus.",
    "regions": {
      "global": "Global",
      "european": "Europäische Sprachen",
      "middleEastern": "Nahöstliche Sprachen",
      "asian": "Asiatische Sprachen",
      "african": "Afrikanische Sprachen"
    }
  },
  "search": {
    "triggerLabel": "HealthLoop durchsuchen",
    "triggerHint": "Versuchen Sie „Schritte“, „Apotheke“ oder „Schwangerschaft“",
    "triggerAriaLabel": "Globale Suche öffnen",
    "placeholder": "Funktionen, Tracker, Support suchen…",
    "inputAriaLabel": "HealthLoop-Funktionen durchsuchen",
    "modalAriaLabel": "HealthLoop durchsuchen",
    "close": "Schließen",
    "clear": "Löschen",
    "clearAriaLabel": "Suche zurücksetzen",
    "recentSearches": "Zuletzt gesucht",
    "tryFor": "Suchen Sie doch mal nach",
    "findFeatures": "Finden Sie jede Funktion in Sekundenschnelle.",
    "searchAcross": "Suchen in",
    "and": "und",
    "sections": {
      "home": "Home",
      "nutrition": "Ernährung",
      "family": "Familie",
      "services": "Services",
      "support": "Support",
      "profile": "Profil"
    },
    "noMatchesFor": "Keine Treffer für „{{query}}“",
    "trySimpler": "Versuchen Sie ein einfacheres Wort wie Schritte, Ernährung oder Spezialist.",
    "comingSoonBadge": "Demnächst",
    "escToClose": "zum Schließen",
    "resultSingular": "{{count}} Ergebnis",
    "resultPlural": "{{count}} Ergebnisse",
    "searchAcrossApp": "In der gesamten App suchen"
  },
  "familyMember": {
    "confirmRemove": "Möchten Sie {{name}} aus dem Familien-Health-Tracking entfernen?",
    "removed": "{{name}} wurde aus der Familie entfernt",
    "removeFailed": "Mitglied konnte nicht entfernt werden",
    "viewDetails": "Details anzeigen",
    "edit": "Bearbeiten",
    "remove": "Entfernen",
    "yearsSuffix": "Jahre",
    "healthGoalsLabel": "Gesundheitsziele:",
    "moreSuffix": "weitere",
    "activeInsights": "Aktive Einblicke",
    "viewAllInsights": "Alle {{count}} Einblicke anzeigen →",
    "viewFullProfile": "Vollständiges Gesundheitsprofil anzeigen",
    "lifeStage": {
      "infant": "Säugling (0-2)",
      "toddler": "Kleinkind (2-5)",
      "child": "Kind (6-12)",
      "adolescent": "Teenager (13-17)",
      "adult": "Erwachsener (18-59)",
      "senior": "Senior (60+)",
      "unknown": "Unbekannt"
    }
  },
  "profileDeep": {
    "backToDashboard": "Zurück zum Dashboard",
    "profileCompletion": "Profil-Vollständigkeit",
    "healthSummary": "Wellness-Zusammenfassung",
    "sectionA": "Abschnitt A",
    "sectionB": "Abschnitt B",
    "sectionC": "Abschnitt C",
    "sectionD": "Abschnitt D",
    "personalDetails": "Persönliche Angaben",
    "healthInformation": "Gesundheitsinformationen",
    "accountSettings": "Kontoeinstellungen",
    "fullName": "Vollständiger Name",
    "email": "E-Mail",
    "dob": "Geburtsdatum",
    "gender": "Geschlecht",
    "genderPlaceholder": "z. B. weiblich, männlich, nicht-binär",
    "height": "Größe (cm)",
    "heightPlaceholder": "z. B. 170",
    "weight": "Gewicht (kg)",
    "weightPlaceholder": "z. B. 70",
    "allergies": "Allergien",
    "allergiesPlaceholder": "z. B. Erdnüsse",
    "medicalConditions": "Bestehende Beschwerden",
    "conditionsPlaceholder": "z. B. Bluthochdruck",
    "medications": "Medikamente",
    "medicationsPlaceholder": "z. B. Lisinopril 10mg, täglich",
    "emergencyContact": "Notfallkontakt",
    "emergencyOptional": "(optional)",
    "emergencyPlaceholder": "z. B. Mutter +49 123 456789",
    "emergencyNote": "Wird nur bei einer Freigabe für Fachpersonal einbezogen, wenn Sie zustimmen.",
    "saveChanges": "Änderungen speichern",
    "saving": "Wird gespeichert…",
    "editProfile": "Profil bearbeiten",
    "cancelEditing": "Bearbeitung abbrechen",
    "healthScore": "Health Score",
    "streak": "Serie",
    "streakDays": "{{n}} Tage",
    "memberSince": "Mitglied seit",
    "remindersActive": "Erinnerungen aktiv",
    "conditionsTracked": "Beobachtete Faktoren",
    "nextAgenda": "Nächster Schritt",
    "notificationsReminders": "Benachrichtigungen & Erinnerungen",
    "notificationsRemindersDesc": "Erinnerungszeiten und Kanäle verwalten",
    "emailNudges": "E-Mail-Anstöße",
    "emailNudgesDesc": "Sanfte Erinnerungen & wöchentliche Zusammenfassungen",
    "on": "An",
    "paused": "Pausiert",
    "privacySecurity": "Datenschutz & Sicherheit",
    "privacySecurityDesc": "Passwort aktualisieren, um Ihr Konto zu schützen",
    "preferencesTitle": "Präferenzen",
    "preferencesDesc": "Sprache, Region und Personalisierung",
    "supportHelp": "Support & Hilfe",
    "supportHelpDesc": "Antworten finden und Kontakt aufnehmen",
    "giveFeedback": "Feedback geben",
    "giveFeedbackDesc": "Helfen Sie uns, besser zu werden",
    "reportProblem": "Problem melden",
    "reportProblemDesc": "Fehler gefunden? Lassen Sie es uns wissen",
    "adminInsights": "Admin-Einblicke",
    "adminInsightsDesc": "Nutzungsstatistiken",
    "adminBadge": "Admin",
    "shareWithClinician": "Mit Fachpersonal teilen",
    "shareWithClinicianDesc": "Nur-Lese-Zusammenfassung · läuft automatisch ab · jederzeit widerrufbar",
    "share": "Teilen",
    "profileMayBeOutOfDate": "Profil könnte veraltet sein",
    "profileMayBeOutOfDateDesc": "Halten Sie Ihre Wellness-Daten aktuell für präzisere Einblicke – selbst kleine Änderungen (Gewicht, Medikamente) helfen uns, Ihre Tipps anzupassen.",
    "updateNow": "Jetzt aktualisieren",
    "profileUpdateError": "Präferenz konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.",
    "healthLoopUser": "HealthLoop-Nutzer",
    "updatedLabel": "Aktualisiert",
    "noEntries": "Noch keine Einträge.",
    "completionComplete": "Ihr Profil ist vollständig. So können wir Sie optimal begleiten. 💚",
    "completionAlmostThere": "Fast geschafft. Ein paar weitere Details ermöglichen präzisere Einblicke.",
    "completionInProgress": "Vervollständigen Sie Ihr Profil für bessere Wellness-Einblicke.",
    "justNow": "gerade eben",
    "minAgo": "vor {{n}} Min.",
    "minsAgo": "vor {{n}} Min.",
    "hourAgo": "vor {{n}} Std.",
    "hoursAgo": "vor {{n}} Std.",
    "dayAgo": "vor {{n}} Tag",
    "daysAgo": "vor {{n}} Tagen",
    "checkinDueToday": "Check-in heute fällig",
    "checkinDueTonight": "Check-in heute Abend fällig"
  },
  "supportDeep": {
    "backToSettings": "Zurück zu den Einstellungen",
    "quickNavAria": "Support-Bereiche",
    "searchPlaceholder": "Hilfe suchen…",
    "searchAria": "Häufig gestellte Fragen durchsuchen",
    "resultsCount": "{{n}} Ergebnis",
    "resultsCountPlural": "{{n}} Ergebnisse",
    "questionsCount": "{{n}} Fragen",
    "liveChatTitle": "Live-Chat",
    "liveChatDesc": "Echtzeit-Austausch · Mo–Fr 9:00–18:00 Uhr",
    "startChat": "Chat starten",
    "liveChatSoonToast": "Der Live-Chat startet bald. Bis dahin hilft Ihnen unser E-Mail-Support gerne weiter.",
    "emailUsTitle": "E-Mail schreiben",
    "emailUsDesc": "Antwort innerhalb von 24–48 Stunden",
    "copy": "Kopieren",
    "emailCopied": "E-Mail-Adresse in Zwischenablage kopiert.",
    "contactFormTitle": "Kontaktformular",
    "contactFormDesc": "Senden Sie uns eine Nachricht – wir antworten per E-Mail.",
    "yourNameLabel": "Ihr Name *",
    "namePlaceholder": "Max Mustermann",
    "yourEmailLabel": "Ihre E-Mail *",
    "emailPlaceholder": "max@beispiel.de",
    "subjectOptional": "Betreff (optional)",
    "subjectPlaceholder": "Wobei können wir helfen?",
    "messageLabel": "Nachricht *",
    "messagePlaceholder": "Beschreiben Sie kurz Ihr Anliegen.",
    "sending": "Wird gesendet…",
    "sendMessage": "Nachricht senden",
    "messageSent": "Nachricht gesendet",
    "messageSentDesc": "Wir antworten innerhalb von 24–48 Stunden.",
    "callbackTitle": "Rückruf anfordern",
    "callbackDesc": "Wir rufen Sie zu einem passenden Zeitpunkt zurück.",
    "phoneLabel": "Telefonnummer *",
    "phonePlaceholder": "+49 (0) 123 456789",
    "preferredTimeLabel": "Bevorzugte Zeit (optional)",
    "preferredTimePlaceholder": "z. B. morgen Nachmittag",
    "reasonLabel": "Grund (optional)",
    "reasonPlaceholder": "Was möchten Sie kurz besprechen?",
    "submitting": "Wird übermittelt…",
    "requestCallback": "Rückruf anfordern",
    "callbackRequested": "Rückruf angefordert",
    "callbackRequestedDesc": "Wir melden uns innerhalb von 24 Stunden.",
    "medicationSupport": "Unterstützung bei Medikation",
    "medicationSupportDesc": "Rezepte, Nachbestellungen und Erinnerungen verwalten.",
    "goToMedications": "Zu den Medikamenten →",
    "specialistConsultation": "Fachberatung",
    "specialistConsultationDesc": "Kontaktieren Sie Fachpersonal für persönliche Wellness-Beratung.",
    "connectExpert": "Experten kontaktieren →",
    "videoConsult": "Video-Beratung",
    "videoConsultDesc": "Buchen Sie ein persönliches Video-Gespräch mit einer Fachkraft.",
    "bookConsultation": "Beratung buchen →",
    "premium": "Premium",
    "healthDisclaimer": "HealthLoop unterstützt Ihr tägliches Wohlbefinden – es ersetzt keine medizinische Notfallversorgung. In dringenden Fällen wenden Sie sich bitte sofort an den Notruf.",
    "categoryLabel": "Kategorie",
    "catBug": "Fehler / Bug",
    "catPerformance": "Langsame Leistung",
    "catFeature": "Funktion geht nicht",
    "catUi": "Anzeigefehler",
    "catOther": "Sonstiges",
    "issueTitle": "Titel des Problems *",
    "issueTitlePlaceholder": "Kurze Zusammenfassung",
    "detailedDescription": "Detaillierte Beschreibung *",
    "detailedDescriptionPlaceholder": "Was ist passiert? Was haben Sie gerade gemacht? Schritte zur Wiederholung helfen uns sehr.",
    "autoAttachNote": "Geräte-, Browser- und Ansichtsdaten werden automatisch angehängt.",
    "submitReport": "Bericht senden",
    "reportSubmitted": "Bericht übermittelt",
    "reportSubmittedDesc": "Unser Team kümmert sich darum.",
    "fillAllFields": "Bitte füllen Sie alle Pflichtfelder aus",
    "problemReportSubmittedToast": "Fehlerbericht gesendet. Wir untersuchen das Problem und melden uns.",
    "messageSentToast": "Nachricht gesendet. Wir antworten innerhalb von 24–48 Stunden.",
    "callRequestedToast": "Rückrufwunsch erhalten. Wir melden uns innerhalb von 24 Stunden.",
    "submitFailGeneric": "Fehler beim Senden. Bitte erneut versuchen oder E-Mail an {{email}} senden.",
    "submitFailContact": "Senden fehlgeschlagen. Bitte senden Sie direkt eine E-Mail an {{email}}.",
    "comingSoon": "Demnächst verfügbar",
    "specialistRoadmapTitle": "Mit Fachpersonal sprechen",
    "specialistRoadmapSubtitle": "Persönliche Begleitung ist in Arbeit. Diese Funktionen werden hier zu finden sein.",
    "talkToSpecialistTitle": "Fachberatung im Chat",
    "talkToSpecialistDesc": "Echtzeit-Chat mit qualifiziertem Fachpersonal für alltägliche Gesundheitsfragen.",
    "bookSpecialistTitle": "Termin bei Fachkraft",
    "bookSpecialistDesc": "Planen Sie eine 1:1-Sitzung mit der passenden Fachkraft für Ihre Ziele.",
    "liveHealthGuidanceTitle": "Live-Wellness-Beratung",
    "liveHealthGuidanceDesc": "Spontane Video-Beratung zu Symptomen, Laborwerten oder Wellness-Plänen.",
    "mentalWellnessTitle": "Mentale Unterstützung",
    "mentalWellnessDesc": "Vertrauliche Hilfe von Experten für mentales Wohlbefinden in belastenden Zeiten.",
    "wellnessNavigationTitle": "Wellness-Navigator",
    "wellnessNavigationDesc": "Eine geführte Tour, die Ihnen hilft, den nächsten richtigen Schritt zu wählen.",
    "pharmacyRoadmapTitle": "Medikamenten- & Apotheken-Support",
    "pharmacyRoadmapSubtitle": "Hilfe rund um die Apotheke finden Sie direkt unter Support & Hilfe.",
    "medicationGuidanceTitle": "Medikations-Ratgeber",
    "medicationGuidanceDesc": "Verständliche Hinweise zu Dosierung, Zeitpunkt und Wechselwirkungen.",
    "findNearbyPharmacyTitle": "Apotheke in der Nähe finden",
    "findNearbyPharmacyDesc": "Finden Sie schnell vertrauenswürdige Apotheken für Ihre Nachbestellungen.",
    "refillReminderTitle": "Nachfüll-Erinnerungen",
    "refillReminderDesc": "Sanfte Hinweise, damit Ihnen wichtige Medikamente nie ausgehen.",
    "otcWellnessTitle": "Beratung zu rezeptfreien Mitteln",
    "otcWellnessDesc": "Kuratierte, evidenzbasierte Tipps zu frei verkäuflichen Wellness-Optionen."
  },
  "careServices": {
    "pageTitle": "Versorgungsangebote",
    "pageSubtitle": "Klinische und Wellness-Unterstützung für Ihren Gesundheitsalltag.",
    "specialistCareTitle": "Fachberatung",
    "specialistCareSubtitle": "Sprechen Sie mit Fachpersonal und buchen Sie Termine bei Experten.",
    "medicationPharmacyTitle": "Medikamente & Apotheke",
    "medicationPharmacySubtitle": "Verständliche Medikationsberatung und Apotheken-Hilfe.",
    "wellnessSupportTitle": "Wellness-Unterstützung",
    "wellnessSupportSubtitle": "Mentales Wohlbefinden und klare Orientierung für nächste Schritte.",
    "futureWellnessTitle": "Zukünftige Wellness-Funktionen",
    "futureWellnessSubtitle": "Ein Ausblick auf die HealthLoop-Roadmap für präventives Wohlbefinden.",
    "futureFeatureBadge": "Zukünftige Funktion",
    "futurePersonalizedMealsTitle": "Personalisierte Ernährungspläne",
    "futurePersonalizedMealsDesc": "Wellness-orientierte Pläne, abgestimmt auf Ihre Ziele und Allergien.",
    "futureHealthyDeliveryTitle": "Gesunde Mahlzeiten-Lieferung",
    "futureHealthyDeliveryDesc": "Kuratierte Lieferung von gesundheitsbewussten Partnern.",
    "futureFarmFreshTitle": "Frische Lebensmittel vom Hof",
    "futureFarmFreshDesc": "Direkter Zugang zu lokalen Höfen und saisonalen Erzeugnissen.",
    "futureFoodPartnershipsTitle": "Wellness-Ernährungspartner",
    "futureFoodPartnershipsDesc": "Kooperationen mit gesunden Küchen und Wellness-Marken.",
    "futureNutritionCoachingTitle": "Ernährungs-Coaching",
    "futureNutritionCoachingDesc": "Persönliche Begleitung durch zertifizierte Ernährungs-Coaches.",
    "futureFamilyWellnessTitle": "Wellness-Pläne für die Familie",
    "futureFamilyWellnessDesc": "Gemeinsame Pläne für den gesunden Alltag des gesamten Haushalts.",
    "futureWellnessPlusTitle": "Wellness+ Mitgliedschaft",
    "futureWellnessPlusDesc": "Premium-Zugang für persönliche Beratung und tiefere Einblicke.",
    "futurePharmacyPartnersTitle": "Apotheken-Partnerschaften",
    "futurePharmacyPartnersDesc": "Vernetzung mit Apotheken für Beratung und Nachbestellungen.",
    "futureAdvancedSpecialistTitle": "Erweiterte Fachberatung",
    "futureAdvancedSpecialistDesc": "Koordinierter Zugang zu Experten und Zweitmeinungen.",
    "futureWellnessMarketplaceTitle": "Wellness-Marktplatz",
    "futureWellnessMarketplaceDesc": "Ein kuratierter Marktplatz für geprüfte Wellness-Produkte.",
    "futureVendorCollabTitle": "Partner-Kollaborationssysteme",
    "futureVendorCollabDesc": "Qualitätssysteme für Partner aus den Bereichen Ernährung und Wellness."
  },
  "dashboardDeep": {
    "healthProfile": "Wellness-Profil",
    "notifications": "Benachrichtigungen",
    "familyAccounts": "Familienkonten",
    "settings": "Einstellungen",
    "logout": "Abmelden",
    "allCaughtUp": "Sie sind auf dem neuesten Stand.",
    "weekInReview": "Ihr Wochenrückblick",
    "dismissNotification": "Benachrichtigung schließen",
    "dismissWeeklyDigest": "Wochenrückblick schließen",
    "notificationsAria": "Benachrichtigungen",
    "profileMenuAria": "Profilmenü öffnen",
    "loadingWellness": "Ihre Wellness-Zusammenfassung wird geladen",
    "nextTip": "Nächster Tipp",
    "todayAtGlance": "Heute im Überblick",
    "healthScoreLabel": "Health Score",
    "currentStreakLabel": "Aktuelle Serie",
    "todaysProgress": "Heutiger Fortschritt",
    "insightForYou": "Einblick für Sie",
    "checkMyHealthRisk": "Wellness-Check starten",
    "quickAccess": "Schnellzugriff",
    "exploreCareServicesTitle": "Angebote entdecken",
    "exploreCareServicesSubtitle": "Fachberatung · Apotheke · Wellness — alles an einem Ort.",
    "familyCare": "Familienvorsorge",
    "healthLibrary": "Wellness-Bibliothek",
    "myHealthData": "Meine Daten",
    "askQuestion": "Frage stellen",
    "dashLoadError": "Dashboard konnte nicht geladen werden. Bitte versuchen Sie es erneut.",
    "taskUpdateError": "Aufgabe konnte nicht aktualisiert werden. Bitte erneut versuchen.",
    "perfectDay": "Perfekter Tag! 🎉 Serie verlängert.",
    "letsStart": "Los geht's",
    "yourNextStepToday": "Ihr nächster Schritt heute",
    "completeDailyCheck": "Vervollständigen Sie Ihren täglichen Check",
    "startDailyCheck": "Daily Check starten",
    "viewAll": "Alle anzeigen",
    "graceProtected": "Serie geschützt",
    "todaysHealthRecommendations": "Heutige Empfehlungen",
    "updateViaCheck": "Per Daily Check aktualisieren",
    "healthInsight": "Wellness-Einblick",
    "riskCheckSubtext": "Persönliche Einblicke in wenigen Sekunden",
    "foodDiet": "Ernährung",
    "healthScoreNew": "Health Score · Neu",
    "letsBuildScore": "Lassen Sie uns gemeinsam an Ihrem Score arbeiten",
    "oneHealthyHabitAtATime": "Eine gesunde Gewohnheit nach der anderen.",
    "nextCheck": "Nächster Check:",
    "todayAt8pm": "Heute um 20:00 Uhr",
    "wellnessTipForYou": "Wellness-Tipp des Tages · Für Sie",
    "wellnessTipForFactor": "Wellness-Tipp des Tages · Für Ihr Thema {{factor}}",
    "logged": "Erfasst",
    "gotIt": "Verstanden 👍",
    "gladToSeeYou": "Schön, dass Sie heute da sind 💚",
    "takesLessThan60Sec": "Dauert weniger als 60 Sekunden",
    "scoreReadyWhenYou": "Bereit, wenn Sie es sind",
    "scoreCompleteFirstCheck": "Schließen Sie Ihren ersten Wellness-Check ab für persönliche Einblicke.",
    "scoreExcellent": "Exzellent",
    "scoreSupportExcellent": "Sie sind heute in einem großartigen Zustand. Weiter so!",
    "scoreGood": "Gut",
    "scoreSupportGood": "Es läuft gut. Behalten Sie Ihre gesunden Gewohnheiten bei.",
    "scoreModerate": "Mäßig",
    "scoreSupportModerate": "Es ist okay, aber einige Bereiche brauchen Aufmerksamkeit.",
    "scoreNeedsAttention": "Achtung nötig",
    "scoreSupportNeedsAttention": "Ihr Wohlbefinden braucht heute Aufmerksamkeit. Kleine Änderungen helfen."
  },
  "emailVerify": {
    "bannerWithEmail": "Bitte bestätigen Sie Ihre E-Mail ({{email}}), um Ihr Konto zu schützen und tägliche Tipps zu erhalten.",
    "bannerNoEmail": "Bitte bestätigen Sie Ihre E-Mail, um Ihr Konto zu schützen und tägliche Tipps zu erhalten.",
    "sending": "Wird gesendet…",
    "resend": "E-Mail erneut senden",
    "sentToast": "Bestätigungs-E-Mail gesendet. Bitte prüfen Sie Ihren Posteingang.",
    "sendFailToast": "E-Mail konnte nicht gesendet werden. Später erneut versuchen."
  },
  "forgotPassword": {
    "title": "Passwort vergessen?",
    "subtitle": "Keine Sorge! Geben Sie Ihre E-Mail an und wir senden Ihnen Instruktionen.",
    "emailLabel": "E-Mail-Adresse",
    "emailPlaceholder": "ihre.email@beispiel.de",
    "sendResetLink": "Link zum Zurücksetzen senden",
    "sending": "Wird gesendet…",
    "backToLogin": "Zurück zum Login",
    "resendLink": "E-Mail erneut senden",
    "successTitle": "Prüfen Sie Ihr Postfach",
    "successBody": "Falls ein Konto für {{email}} existiert, haben wir einen Link gesendet.",
    "linkExpires": "Der Link ist 30 Minuten lang gültig.",
    "successToast": "Prüfen Sie Ihre E-Mails für weitere Schritte",
    "errEmptyEmail": "Bitte geben Sie Ihre E-Mail-Adresse ein",
    "errInvalidEmail": "Bitte eine gültige E-Mail-Adresse eingeben",
    "errNetwork": "Server nicht erreichbar. Bitte Verbindung prüfen.",
    "errGeneric": "E-Mail konnte nicht gesendet werden. Bitte Support kontaktieren."
  },
  "resetPassword": {
    "title": "Neues Passwort festlegen",
    "subtitle": "Erstellen Sie ein sicheres Passwort für Ihr Konto",
    "newPasswordLabel": "Neues Passwort",
    "newPasswordPlaceholder": "Neues Passwort eingeben",
    "confirmPasswordLabel": "Passwort bestätigen",
    "confirmPasswordPlaceholder": "Neues Passwort bestätigen",
    "requirementsHint": "Mindestens 8 Zeichen, Groß- und Kleinschreibung sowie eine Zahl",
    "resetPassword": "Passwort zurücksetzen",
    "resetting": "Wird zurückgesetzt…",
    "successTitle": "Passwort erfolgreich geändert!",
    "successBody": "Sie können sich nun mit Ihrem neuen Passwort anmelden.",
    "successToast": "Passwort erfolgreich zurückgesetzt!",
    "goToLogin": "Zum Login",
    "invalidLinkTitle": "Ungültiger Link",
    "invalidLinkBody": "Dieser Link ist ungültig oder abgelaufen.",
    "requestNewLink": "Neuen Link anfordern",
    "showPassword": "Passwort anzeigen",
    "hidePassword": "Passwort verbergen",
    "errInvalidLink": "Ungültiger Link zum Zurücksetzen",
    "errMismatch": "Passwörter stimmen nicht überein",
    "errTooShort": "Passwort muss mindestens 8 Zeichen lang sein",
    "errExpiredToken": "Dieser Link ist abgelaufen. Bitte fordern Sie einen neuen an.",
    "errNetwork": "Server nicht erreichbar. Bitte Verbindung prüfen.",
    "errGeneric": "Passwort konnte nicht zurückgesetzt werden. Bitte erneut versuchen."
  },
  "tips": {
    "water1": "Ein Glas Wasser innerhalb von 30 Minuten nach dem Aufwachen fördert die Flüssigkeitszufuhr und das Energieniveau.",
    "water2": "Ein Glas Wasser vor jeder Mahlzeit hilft, den Durst sanft im Blick zu behalten.",
    "water3": "Mit einer Scheibe Zitrone oder Minzblättern wird das Trinken zu einem kleinen Genuss.",
    "meals1": "Eine zusätzliche Portion Gemüse am Tag unterstützt die Darm- und Herzgesundheit.",
    "meals2": "Eine Handvoll Nüsse oder Samen zum Frühstück stabilisiert die Energie über den Vormittag.",
    "meals3": "Ganze Früchte sind besser als Saft – die Ballaststoffe halten den Blutzucker stabil.",
    "steps1": "Ein 10-minütiger Spaziergang nach dem Essen hilft dem Körper, Zucker sanft zu verarbeiten.",
    "steps2": "5 Minuten Dehnen am Morgen lösen Spannungen und sorgen für einen ruhigen Start.",
    "steps3": "Schon einmal am Tag die Treppe zu nehmen, stärkt über die Wochen hinweg das Herz.",
    "sleep1": "Licht dimmen eine Stunde vor dem Schlafen hilft dem Körper, zur Ruhe zu kommen.",
    "sleep2": "Regelmäßige Aufwachzeiten – auch am Wochenende – festigen den Schlafzyklus.",
    "sleep3": "10 Minuten Sonnenlicht am Morgen regulieren den Schlafrhythmus ganz natürlich.",
    "general1": "Zwei Minuten bewusstes Atmen können Stress senken und den Fokus stärken.",
    "general2": "Achten Sie heute auf einen Moment der Dankbarkeit – auch kleine Erfolge zählen.",
    "general3": "Sie sind heute aktiv geworden. Das ist die Gewohnheit, die alles andere einfacher macht."
  },
  "factors": {
    "hydration": "Flüssigkeitszufuhr",
    "nutrition": "Ernährung",
    "movement": "Bewegung",
    "sleep": "Schlaf"
  },
  "nutritionDeep": {
    "mealOptionsLoadFail": "Mahlzeitoptionen konnten nicht geladen werden",
    "prefsSaved": "Ernährungspräferenzen gespeichert! Mahlzeiten werden aktualisiert...",
    "prefsSaveFail": "Speichern der Präferenzen fehlgeschlagen",
    "newOptionsFail": "Neue Optionen konnten nicht geladen werden",
    "invalidZip": "Bitte geben Sie eine gültige 5-stellige Postleitzahl ein",
    "noVendorsArea": "In diesem Gebiet sind noch keine Anbieter verfügbar. Wir erweitern unser Angebot!",
    "vendorsFetchFail": "Anbieter konnten nicht geladen werden",
    "selectVendorFirst": "Bitte wählen Sie zuerst einen Lieferdienst aus",
    "removedFromCart": "Aus dem Warenkorb entfernt",
    "orderPlaced": "Bestellung erfolgreich aufgegeben! 🎉",
    "enterZipFirst": "Bitte geben Sie zuerst Ihre Postleitzahl im Bereich Lieferung ein",
    "mealNotAvailable": "Diese Mahlzeit ist in Ihrer Region noch nicht zur Lieferung verfügbar",
    "mealUnavailable": "Diese Mahlzeit ist derzeit bei Anbietern in Ihrer Nähe nicht verfügbar",
    "vendorOptionsFail": "Anbieteroptionen konnten nicht geladen werden",
    "favoriteSaveFail": "Favorit konnte nicht gespeichert werden",
    "removedFromFavorites": "Aus den Favoriten entfernt",
    "favoriteRemoveFail": "Favorit konnte nicht entfernt werden",
    "cartEmpty": "Ihr Warenkorb ist leer",
    "noMealOptions": "Keine Mahlzeitoptionen verfügbar",
    "loadingOptions": "Mahlzeitoptionen werden geladen...",
    "selectPreferences": "Wählen Sie Ihre Ernährungspräferenzen",
    "mealBuilder": "Mahlzeiten-Planer",
    "myFavorites": "Meine Favoriten",
    "myFavoriteMeals": "Meine Lieblingsgerichte",
    "noFavoritesYet": "Noch keine Lieblingsgerichte gespeichert!",
    "price": "Preis",
    "delivery": "Lieferung",
    "deliveryFee": "Liefergebühr",
    "distance": "Entfernung",
    "subtotal": "Zwischensumme",
    "total": "Gesamtbetrag",
    "orderNumber": "Bestellnummer",
    "vendor": "Anbieter",
    "totalAmount": "Gesamtbetrag",
    "estimatedDelivery": "Voraussichtliche Lieferung",
    "whyThisMeal": "Warum diese Mahlzeit?",
    "selectThisMeal": "Diese Mahlzeit wählen",
    "swapMeal": "Mahlzeit tauschen",
    "orderThisMeal": "Diese Mahlzeit bestellen",
    "notAvailableNearYou": "In Ihrer Nähe nicht verfügbar",
    "tryAdjustingPrefs": "Passen Sie Ihre Präferenzen an, um Vorschläge zu erhalten",
    "myMealPlanSummary": "Zusammenfassung meines Ernährungsplans",
    "saveCompletePlan": "Gesamten Plan speichern",
    "yourFoodPreferences": "Ihre Ernährungspräferenzen",
    "editPreferences": "Präferenzen bearbeiten",
    "healthyMealDelivery": "Gesunde Mahlzeitenlieferung",
    "enableDelivery": "Lieferung aktivieren",
    "enterZipCode": "PLZ eingeben, um verfügbare Mahlzeiten zu sehen",
    "enterPostcode": "Geben Sie Ihre Postleitzahl ein",
    "postcodePlaceholder": "z. B. 10115",
    "postcodePartialHint": "Bitte geben Sie Ihre vollständige Postleitzahl für genauere Ergebnisse ein.",
    "noLocalPartnersFallback": "Noch keine lokalen Partner gefunden. Wir zeigen Ihnen stattdessen passende Zutaten-Vorschläge.",
    "noLivePartnersFallback": "In Ihrer Region sind derzeit noch keine HealthLoop-Partner aktiv.",
    "culturalNutritionTitle": "Gesundes in Ihrer Nähe entdecken",
    "culturalNutritionSubtitle": "Personalisierte Wellness-Beratung — informativ und auf Ihre Region abgestimmt.",
    "viewIngredientGuidance": "Empfehlungen ansehen",
    "popularWellnessTitle": "Beliebte Wellness-Lebensmittel in Ihrer Nähe",
    "popularWellnessIntro": "Passende Zutaten und gesunde Optionen, die in Ihrer Region häufig genutzt werden.",
    "subsectionPopularFoodsTitle": "Alltägliche Wellness-Lebensmittel",
    "subsectionCulturalIngredientsTitle": "Regionale Zutaten-Vorschläge",
    "subsectionHealthySwapsTitle": "Ideen für gesunde Alternativen",
    "subsectionLocalEnvironmentTitle": "Regionales Wellness-Umfeld",
    "subsectionLocalEnvironmentIntro": "Orte in Ihrer Nähe mit gesunden und passenden Optionen.",
    "findLocalTitle": "Gesunde Optionen vor Ort",
    "findLocalSubtitle": "Entdecken Sie gesunde Anbieter, Geschäfte und passende Zutaten in Ihrer Nähe.",
    "findOptions": "Optionen finden",
    "searching": "Suche läuft…",
    "nearbyVendorsFound": "{{count}} gesunde Optionen in der Nähe gefunden",
    "orderHintEnabled": "Tippen Sie auf „Diese Mahlzeit bestellen“, um die Preise der Anbieter zu sehen.",
    "orderHintDisabled": "Aktivieren Sie oben die Lieferung, um direkt über die Karten zu bestellen.",
    "localIngredientTitle": "Lokale Verfügbarkeit von Zutaten",
    "localIngredientIntro": "Wichtige Zutaten und wo Sie diese vor Ort finden.",
    "lookFor": "Suchen Sie nach",
    "noVendorsFallback": "Noch keine zertifizierten Lieferdienste verfügbar – die Zutaten-Tipps oben helfen Ihnen aber auch im Supermarkt oder auf dem Wochenmarkt weiter.",
    "showingMealsFrom": "Mahlzeiten von",
    "sectionSnapshot": "Tagesübersicht Ernährung",
    "sectionSnapshotSubtitle": "Ein kurzer Blick auf Flüssigkeit, Kalorien und Ausgewogenheit für heute.",
    "snapshotHydration": "Flüssigkeitszufuhr",
    "snapshotHydrationHint": "Ziel: 6–8 Gläser pro Tag.",
    "snapshotCalories": "Kalorien",
    "snapshotCaloriesHint": "Tracking bald verfügbar.",
    "snapshotBalance": "Ausgewogenheit",
    "mealsLogged": "Mahlzeiten gewählt",
    "snapshotTip": "Wellness-Tipp",
    "snapshotTipHint": "Fügen Sie Ihrer nächsten Mahlzeit eine extra Portion Gemüse hinzu.",
    "sectionRecommendations": "Intelligente Empfehlungen",
    "sectionRecommendationsSubtitle": "Passende Zutaten-Tipps und Ideen für gesunde Alternativen.",
    "sectionGoals": "Ernährungsziele",
    "sectionGoalsSubtitle": "Verfolgen Sie Ziele, die Ihnen wichtig sind.",
    "goalWeight": "Gewichtsmanagement",
    "goalWeightDesc": "Mahlzeiten für ein nachhaltiges Gewichtsziel.",
    "goalEnergy": "Energie-Unterstützung",
    "goalEnergyDesc": "Konstante Energie für lange, produktive Tage.",
    "goalImmunity": "Immunsystem stärken",
    "goalImmunityDesc": "Antioxidantienreiche Auswahl für Ihre Widerstandskraft.",
    "goalFamily": "Ernährung für die Familie",
    "goalFamilyDesc": "Einschließlich kinderfreundlicher und mütterlicher Optionen.",
    "sectionGuidance": "Orientierungshilfe Mahlzeiten",
    "sectionGuidanceSubtitle": "Ideen für Frühstück, Mittag, Abendessen und Snacks zum Tauschen.",
    "futureNutritionTitle": "Zukünftige Ernährungs-Features",
    "futureNutritionBody": "Personalisierte Wellness-Ernährung, Partnerschaften für gesunde Mahlzeiten und familiengerechte Unterstützung folgen in kommenden Updates.",
    "comingSoon": "Demnächst verfügbar",
    "coverageLocalStores": "Lokale Bioläden",
    "coverageLocalFarms": "Hofläden in der Nähe",
    "coverageCertifiedVendors": "Zertifizierte Anbieter",
    "coverageFreshProduce": "Frische Erzeugnisse",
    "medWellnessFutureTitle": "Unterstützung für Wellness",
    "medWellnessFutureDesc": "Verknüpft Ihren Ernährungsplan mit bewusst gewählter Wellness-Beratung. Details unter „Support & Hilfe“.",
    "pharmacyAssistFutureTitle": "Apotheken-Unterstützung",
    "pharmacyAssistFutureDesc": "Finden Sie Apotheken in Ihrer Nähe direkt neben Ihren Mahlzeit-Optionen. Details unter „Support & Hilfe“.",
    "savePreferences": "Präferenzen speichern",
    "quickAccessSavedMeals": "Schneller Zugriff auf gespeicherte Mahlzeiten",
    "saveMealsFromBuilder": "Speichern Sie Mahlzeiten im Planer",
    "chooseVendor": "Anbieter für diese Mahlzeit wählen",
    "yourCart": "Ihr Warenkorb",
    "addMealsToStart": "Fügen Sie Mahlzeiten hinzu, um zu beginnen",
    "orderPlacedDesc": "Ihre Bestellung für eine gesunde Mahlzeit wurde erfolgreich aufgegeben",
    "continueShopping": "Weiter einkaufen",
    "trackOrder": "Bestellung verfolgen",
    "healthyStoresTitle": "Märkte für gesundes Leben & Wohlbefinden in Ihrer Nähe",
    "healthyStoresIntro": "Kulturell vielfältige Geschäftstypen in Ihrer Region – zur Inspiration, kein Lieferdienst.",
    "healthyStoresGuidanceTitle": "Anleitungen für gesundes Einkaufen",
    "healthyStoresDisclaimer": "HealthLoop bietet lediglich allgemeine Inspirationen für Wohlbefinden und gesundes Einkaufen – keine medizinische Beratung oder Ernährungstherapie.",
    "healthyStores": {
      "organic": {
        "type": "Bio-Lebensmittelgeschäfte",
        "description": "Frische, pestizidfreie Produkte und naturbelassene Grundnahrungsmittel.",
        "tags": [
          "Vollwertkost",
          "Frische Erzeugnisse"
        ]
      },
      "farmers": {
        "type": "Wochenmärkte",
        "description": "Regional angebautes saisonales Obst, Gemüse und traditionelle Erzeugnisse direkt vom Erzeuger.",
        "tags": [
          "Regional",
          "Saisonal"
        ]
      },
      "african": {
        "type": "Afrikanische Lebensmittelgeschäfte",
        "description": "Yams, Kochbananen, Blattgemüse, Palmnüsse und west-/ostafrikanische Grundnahrungsmittel.",
        "tags": [
          "Kulturell",
          "Frische Erzeugnisse"
        ]
      },
      "caribbean": {
        "type": "Karibische Naturkostmärkte",
        "description": "Callaloo, Maniok, Scotch Bonnet, Ackee, Brotfrucht und Spezialitäten der Inseln.",
        "tags": [
          "Kulturell",
          "Vollwertkost"
        ]
      },
      "asian": {
        "type": "Asiatische Supermärkte",
        "description": "Bok Choy, Daikon, Lotuswurzel, Tofu, frische Kräuter und panasiatische Grundnahrungsmittel.",
        "tags": [
          "Kulturell",
          "Frische Erzeugnisse"
        ]
      },
      "halal": {
        "type": "Halal-Märkte für gesunde Ernährung",
        "description": "Halal-zertifizierte magere Proteine, frisches Gemüse und traditionelle Gewürze.",
        "tags": [
          "Halal",
          "Kulturell"
        ]
      },
      "mediterranean": {
        "type": "Mediterrane Vollwertmärkte",
        "description": "Olivenöl, Hülsenfrüchte, frische Kräuter, Vollkornprodukte und mediterrane Spezialitäten.",
        "tags": [
          "Kulturell",
          "Vollwertkost"
        ]
      },
      "wellness": {
        "type": "Wellness-orientierte Lebensmittelgeschäfte",
        "description": "Ausgewählte Vollwertkost, pflanzliche Optionen und Produkte mit natürlichen Inhaltsstoffen.",
        "tags": [
          "Vollwertkost",
          "Pflanzlich"
        ]
      }
    },
    "healthyShoppingTips": [
      "Kaufen Sie zuerst in den Außenbereichen ein – dort finden Sie meist frisches Gemüse, magere Proteine und Milchalternativen.",
      "Bevorzugen Sie unverarbeitete Lebensmittel mit nur einer Zutat gegenüber stark verarbeiteten Produkten.",
      "Wählen Sie saisonale regionale Produkte – diese sind meist frischer, preiswerter und nährstoffreicher.",
      "Fragen Sie die Händler nach der Herkunft und den Anbaumethoden – viele geben gerne Auskunft."
    ]
  },
  "messages": {
    "success": "Erfolgreich!",
    "error": "Fehler",
    "saved": "Erfolgreich gespeichert",
    "updated": "Erfolgreich aktualisiert",
    "deleted": "Erfolgreich gelöscht",
    "confirmDelete": "Sind Sie sicher, dass Sie dies löschen möchten?",
    "networkError": "Netzwerkfehler. Bitte versuchen Sie es erneut.",
    "somethingWrong": "Etwas ist schiefgelaufen",
    "failedToLoad": "Dashboard konnte nicht geladen werden",
    "offlineMode": "Offline-Modus – es werden begrenzte Daten angezeigt",
    "locationDenied": "Standortzugriff verweigert. Prüfen Sie die Browsereinstellungen.",
    "locationUnavailable": "Standortinformationen nicht verfügbar",
    "locationTimeout": "Zeitüberschreitung bei Standortanfrage. Bitte erneut versuchen.",
    "locationError": "Zugriff auf Standort nicht möglich",
    "locationGranted": "Standortzugriff gewährt! Optionen in Ihrer Nähe werden angezeigt",
    "locationNotSupported": "Standortdienste werden von Ihrem Browser nicht unterstützt",
    "requestingLocation": "Standortzugriff wird angefordert..."
  },
  "trust": {
    "medicalDisclaimer": "Haftungsausschluss",
    "privacySecure": "Ihre Daten sind privat & sicher",
    "dataEncrypted": "Alle Daten sind verschlüsselt und vertraulich",
    "notMedicalAdvice": "Keine medizinische Beratung",
    "consultProvider": "Konsultieren Sie stets Ihre medizinische Fachkraft",
    "evidenceBased": "Evidenzbasierte Beratung",
    "generalEducation": "Allgemeine Gesundheitsbildung",
    "preventiveGuidance": "Präventive Beratung",
    "lifestyleSupport": "Zur Information und Lifestyle-Unterstützung",
    "lastUpdated": "Zuletzt aktualisiert",
    "expertReviewed": "Von Experten geprüft",
    "aiGenerated": "KI-generierte Erkenntnis",
    "disclaimerShort": "HealthLoop bietet Gesundheitsbildung an und ersetzt keine professionelle medizinische Beratung.",
    "disclaimerFull": "HealthLoop unterstützt präventives Wohlbefinden und frühe Achtsamkeit. Wir bieten Gesundheitsbildung, Gewohnheitstracking und Wellness-Einblicke. Dies ist kein Ersatz für eine ärztliche Behandlung. Konsultieren Sie bei Fragen zu Gesundheit oder Therapie stets qualifizierte medizinische Fachkräfte.",
    "trustBanner": {
      "title": "HealthLoop begleitet Sie auf Ihrem Wellness-Weg",
      "description": "Wir bieten allgemeine Gesundheitsbildung und präventive Beratung basierend auf vertrauenswürdigen Quellen. Dies ersetzt keine professionelle medizinische Beratung. Konsultieren Sie bei medizinischen Entscheidungen stets qualifizierte Fachkräfte."
    }
  },
  "health": {
    "preventiveHealth": "Präventions-Tracker",
    "educationHub": "Wissensbereich",
    "engagementWidget": "Aktivitäts-Widget",
    "wellnessCheckIn": "Wellness-Check-in",
    "todaysMetrics": "Heutige Werte",
    "bloodPressure": "Blutdruck",
    "heartRate": "Herzfrequenz",
    "weight": "Gewicht",
    "sleep": "Schlaf",
    "waterIntake": "Wasserzufuhr",
    "exercise": "Bewegung",
    "logMetric": "Wert eintragen",
    "viewHistory": "Verlauf ansehen"
  },
  "aiInsights": {
    "title": "KI-Wellness-Einblicke",
    "comingSoon": "Ihre Einblicke werden vorbereitet",
    "comingSoonDesc": "Führen Sie ein paar tägliche Check-ins durch, damit wir Ihnen hier personalisierte Tipps geben können.",
    "learnMore": "Mehr erfahren",
    "evidenceSources": {
      "WHO": "Basierend auf WHO-Richtlinien",
      "NHS": "Abgestimmt auf NHS-Empfehlungen",
      "CDC": "Unterstützt durch CDC-Richtlinien",
      "RESEARCH": "Basierend auf wissenschaftlicher Forschung",
      "CLINICAL": "Durch klinische Studien belegt"
    }
  },
  "dailyInsight": {
    "title": "Täglicher Wellness-Einblick",
    "gettingStarted": "Erste Schritte",
    "focus": "Fokus",
    "quickInsight": "Kurz-Einblick",
    "simpleExplanation": "Einfache Erklärung",
    "realLifeImpact": "Einfluss auf den Alltag",
    "yourActionStep": "Ihr nächster Schritt",
    "basedOnYour": "Basierend auf Ihrem/Ihrer",
    "personalizedFor": "Für Sie personalisiert auf Basis Ihrer aktuellen Daten",
    "getNewInsight": "Neuen Einblick erhalten",
    "newInsightLoaded": "Neuer Einblick geladen! 💡",
    "failedToRefresh": "Einblick konnte nicht aktualisiert werden",
    "priority": {
      "high": "Darauf sollten wir achten",
      "medium": "Beachtenswert"
    }
  },
  "preventiveAlerts": {
    "noAlertsTitle": "Derzeit keine Hinweise",
    "noAlertsDesc": "Sie pflegen gesunde Gewohnheiten. Weiter so!",
    "whatYouCanDo": "Was Sie tun können:",
    "viewMealSuggestions": "Personalisierte Mahlzeiten ansehen"
  },
  "engagement": {
    "currentStreak": "Aktuelle Serie",
    "bestStreak": "Beste Serie",
    "thisWeek": "Diese Woche",
    "exerciseDays": "Tage mit Bewegung",
    "hydrationDays": "Tage mit genug Wasser",
    "healthMetricsLogged": "Eingetragene Werte",
    "weeklyGoalsProgress": "Fortschritt Wochenziele",
    "completed": "abgeschlossen",
    "days": "Tage",
    "keepGoing": "Weiter so!",
    "personalRecord": "Persönlicher Rekord!",
    "goalMet": "Ziel erreicht!"
  },
  "reminders": {
    "title": "Gesundheits-Erinnerungen",
    "subtitle": "Bleiben Sie mit personalisierten Benachrichtigungen am Ball",
    "breakfast": "Erinnerung Frühstück",
    "lunch": "Erinnerung Mittagessen",
    "dinner": "Erinnerung Abendessen",
    "water": "Wasser trinken",
    "movement": "Bewegungspause",
    "sleep": "Erinnerung Schlafenszeit",
    "wellness": "Wellness-Check-in",
    "healthLogging": "Werte eintragen",
    "annualCheckup": "Vorsorgeuntersuchung",
    "enable": "Aktivieren",
    "disable": "Deaktivieren",
    "customize": "Zeit anpassen",
    "stayConsistent": "Dranbleiben mit smarten Erinnerungen",
    "setupFriendly": "Richten Sie freundliche Erinnerungen ein, um gesunde Routinen aufzubauen.",
    "customizeWhen": "Sie können festlegen, wann und wie oft Sie erinnert werden möchten.",
    "supportive": "Keine Sorge – wir gestalten die Hinweise motivierend und dezent! 💚",
    "noPreferences": "Keine Einstellungen gefunden",
    "noPreferencesDesc": "Ihre Einstellungen konnten nicht geladen werden. Vielleicht sind Sie zum ersten Mal hier.",
    "retryLoading": "Erneut versuchen",
    "saveSettings": "Einstellungen speichern",
    "saving": "Wird gespeichert..."
  },
  "empty": {
    "startJourney": "Starten Sie Ihren Wellness-Weg",
    "startJourneyDesc": "Beginnen Sie heute! Teilen Sie uns mit, wie Sie sich fühlen, um personalisierte Einblicke zu erhalten.",
    "completeFirstCheckIn": "Ersten Check-in ausfüllen",
    "stayOnTrack": "Am Ball bleiben",
    "stayOnTrackDesc": "Bleiben Sie bei Ihrer Routine 💊 Fügen Sie wichtige Wellness-Elemente hinzu, um Unterstützung zu erhalten.",
    "addFirstMedication": "Erstes Element hinzufügen",
    "learnMedicationSafety": "Mehr über Sicherheit erfahren",
    "buildMealLibrary": "Eigene Mahlzeiten-Sammlung",
    "buildMealLibraryDesc": "Noch keine Favoriten. Speichern Sie Mahlzeiten für eine einfachere Planung.",
    "exploreMealOptions": "Optionen entdecken",
    "insightsAwait": "Ihre Einblicke warten",
    "insightsAwaitDesc": "Nutzen Sie den täglichen Check-in, um Muster und personalisierte Wellness-Einblicke freizuschalten.",
    "startDailyCheckIn": "Täglichen Check-in starten",
    "learnAboutInsights": "Mehr über Einblicke erfahren",
    "buildingStory": "Ihre Wellness-Geschichte schreiben",
    "buildingStoryDesc": "Noch keine Daten vorhanden. Ihre Trends erscheinen hier, sobald Sie die Check-ins nutzen.",
    "completeCheckIn": "Check-in ausfüllen",
    "tipComplete7Days": "Tipp: Nutzen Sie den Check-in 7 Tage lang, um aussagekräftige Trends zu sehen.",
    "startTrackingHabits": "Gesunde Gewohnheiten verfolgen",
    "startTrackingHabitsDesc": "Noch keine Gewohnheiten erfasst. Kleine tägliche Schritte führen zu nachhaltigem Wohlbefinden.",
    "trackFirstHabit": "Erste Gewohnheit eintragen",
    "getMoving": "In Bewegung kommen",
    "getMovingDesc": "Noch keine Aktivität geloggt. Schon 10 Minuten Bewegung verbessern Stimmung und Energie.",
    "logActivity": "Aktivität eintragen",
    "allCaughtUp": "Alles aktuell!",
    "allCaughtUpDesc": "Sie haben keine neuen Benachrichtigungen. Schauen Sie später wieder vorbei.",
    "noResultsFound": "Keine Ergebnisse gefunden",
    "noResultsFoundDesc": "Wir konnten nichts für „{query}“ finden. Passen Sie Ihre Suche an oder entdecken Sie andere Optionen."
  },
  "footer": {
    "tagline": "Ihr KI-gestützter Begleiter für die Gesundheitsvorsorge",
    "builtWith": "Mit Sorgfalt für Ihr Wohlbefinden entwickelt",
    "allRightsReserved": "Alle Rechte vorbehalten.",
    "about": "Über uns",
    "privacy": "Datenschutz",
    "terms": "AGB",
    "contact": "Kontakt",
    "helpCenter": "Hilfe-Center"
  },
  "modals": {
    "feedback": {
      "title": "Teilen Sie Ihr Feedback",
      "subtitle": "Helfen Sie uns, HealthLoop zu verbessern",
      "whatWorking": "Was gefällt Ihnen gut?",
      "whatImprove": "Was können wir verbessern?",
      "placeholder": "Ihre Gedanken...",
      "thankYou": "Vielen Dank für Ihr Feedback!",
      "submitted": "Ihre Rückmeldung hilft uns dabei, HealthLoop stetig zu optimieren."
    },
    "reportProblem": {
      "title": "Ein Problem melden",
      "subtitle": "Helfen Sie uns, Fehler zu beheben",
      "describe": "Beschreiben Sie das Problem",
      "placeholder": "Was ist passiert? Bitte seien Sie so genau wie möglich...",
      "optional": "Optional: Schritte zur Reproduktion",
      "stepsPlaceholder": "1. Ich habe geklickt auf...\n2. Dann ist...",
      "thankYou": "Vielen Dank für die Meldung!",
      "submitted": "Wir werden uns umgehend darum kümmern."
    },
    "mealPreferences": {
      "title": "Mahlzeiten anpassen",
      "subtitle": "Verraten Sie uns Ihre Vorlieben beim Essen",
      "cuisines": "Bevorzugte Küche",
      "selectCuisines": "Wählen Sie alles aus, was zutrifft",
      "dietary": "Ernährungsweise",
      "selectDietary": "Wählen Sie Ihre Ernährungsbedürfnisse",
      "allergies": "Allergien & Unverträglichkeiten",
      "allergiesPlaceholder": "z. B. Nüsse, Schalentiere, Gluten",
      "save": "Einstellungen speichern",
      "saving": "Wird gespeichert..."
    },
    "upgrade": {
      "title": "Auf Premium upgraden",
      "subtitle": "Alle Funktionen freischalten",
      "features": "Premium-Funktionen",
      "getStarted": "Jetzt starten",
      "learnMore": "Mehr erfahren"
    }
  },
  "login": {
    "title": "Ihre Intelligenz-Plattform für Gesundheitsvorsorge",
    "subtitle": "Behalten Sie den Überblick, lernen Sie dazu und handeln Sie, bevor Probleme entstehen. Entwickelt für Prävention, Aufklärung und Wohlbefinden.",
    "email": "E-Mail",
    "password": "Passwort",
    "signIn": "Anmelden",
    "signingIn": "Anmeldung läuft...",
    "forgotPassword": "Passwort vergessen?",
    "noAccount": "Noch kein Konto?",
    "createAccount": "Konto erstellen",
    "biometricLogin": "Biometrische Anmeldung",
    "biometricHelper": "Verwenden Sie Fingerabdruck, Face ID oder Windows Hello",
    "authenticating": "Authentifizierung...",
    "vendorPartner": "Sind Sie ein Partner-Unternehmen?",
    "vendorLogin": "Partner-Login",
    "emailRequired": "Bitte geben Sie zuerst Ihre E-Mail-Adresse ein",
    "biometricSuccess": "Anmeldung per Biometrie erfolgreich! 🎉",
    "noPasskeys": "Keine biometrische Anmeldung eingerichtet. Bitte nutzen Sie zuerst die Anmeldung per Passwort.",
    "biometricCancelled": "Biometrische Anmeldung abgebrochen",
    "biometricFailed": "Biometrische Anmeldung fehlgeschlagen. Bitte versuchen Sie es mit Ihrem Passwort."
  },
  "register": {
    "title": "HealthLoop beitreten",
    "subtitle": "Starten Sie noch heute Ihre Reise zur Gesundheitsvorsorge",
    "fullName": "Vollständiger Name",
    "email": "E-Mail",
    "password": "Passwort",
    "confirmPassword": "Passwort bestätigen",
    "createAccount": "Konto erstellen",
    "haveAccount": "Sie haben bereits ein Konto?",
    "signIn": "Anmelden",
    "creating": "Konto wird erstellt...",
    "passwordTooShort": "Das Passwort muss mindestens 8 Zeichen lang sein",
    "setupBiometric": "Biometrische Anmeldung einrichten",
    "setupBiometricDesc": "Nutzen Sie Fingerabdruck, Face ID oder Windows Hello für eine schnellere und sicherere Anmeldung",
    "setupNow": "Biometrie jetzt einrichten",
    "skipForNow": "Vorerst überspringen",
    "settingUp": "Einrichtung läuft...",
    "benefit1": "Keine Passwörter mehr merken",
    "benefit2": "Besonders sicher durch biometrische Verifizierung",
    "benefit3": "Anmeldung mit nur einem Fingertipp oder Blick",
    "biometricPrivacy": "Ihre biometrischen Daten verlassen niemals Ihr Gerät",
    "biometricSuccess": "Biometrische Anmeldung erfolgreich eingerichtet! 🎉",
    "biometricFailed": "Einrichtung fehlgeschlagen. Sie können dies später in den Einstellungen nachholen.",
    "biometricSetupLater": "Sie können die biometrische Anmeldung später in Ihren Profileinstellungen aktivieren"
  },
  "womensHealthPage": {
    "title": "Frauengesundheit",
    "subtitle": "Zyklus, Symptome und Wohlbefinden im Blick",
    "cycleOverview": "Zyklus-Übersicht",
    "currentPhase": "Aktuelle Phase",
    "nextPeriod": "Nächste Periode erwartet am",
    "logPeriod": "Periode protokollieren",
    "logSymptoms": "Symptome erfassen",
    "insights": "Zyklus-Analysen",
    "tips": "Tipps passend zur Phase",
    "history": "Zyklus-Historie",
    "noData": "Noch keine Zyklusdaten vorhanden",
    "noDataDesc": "Beginnen Sie mit der Protokollierung, um personalisierte Wellness-Hinweise und Vorhersagen zu erhalten.",
    "startTracking": "Tracking starten"
  },
  "notifications": {
    "title": "Benachrichtigungen",
    "markAllRead": "Alle als gelesen markieren",
    "noNotifications": "Keine neuen Benachrichtigungen",
    "viewAll": "Alle anzeigen"
  },
  "familyHealth": {
    "title": "Familie & Kinder",
    "subtitle": "Vorsorge-Unterstützung für Ihre ganze Familie",
    "tabImmunizations": "Impfungen",
    "tabEducation": "Wissen",
    "tabReminders": "Erinnerungen",
    "tabPlanner": "Familienplaner",
    "immunizations": {
      "title": "Impfschutz-Bewusstsein",
      "subtitle": "Bleiben Sie über empfohlene Impfungen informiert",
      "recommendedSchedule": "Empfohlener Zeitplan",
      "byAge": "Nach Altersgruppe",
      "infants": "Säuglinge (0-12 Monate)",
      "toddlers": "Kleinkinder (1-3 Jahre)",
      "preschool": "Vorschulkinder (4-6 Jahre)",
      "schoolAge": "Schulkinder (7-12 Jahre)",
      "teens": "Jugendliche (13-18 Jahre)",
      "adults": "Erwachsene",
      "learnMore": "Mehr erfahren",
      "consultDoctor": "Wenden Sie sich für eine persönliche Beratung zu Impfempfehlungen stets an Ihre hausärztliche Praxis",
      "upcomingReminders": "Anstehende Impftermine",
      "noReminders": "Keine anstehenden Impftermine",
      "addReminder": "Impferinnerung hinzufügen",
      "reminderFor": "Erinnerung für",
      "dueDate": "Fällig am",
      "notes": "Notizen",
      "markComplete": "Als erledigt markieren"
    },
    "education": {
      "title": "Wissen für die Familie",
      "subtitle": "Fundierte Informationen zur Gesundheitsvorsorge",
      "categories": "Kategorien",
      "infant": "Säuglingspflege",
      "child": "Kindliche Entwicklung",
      "nutrition": "Ernährung & Wachstum",
      "safety": "Sicherheit & Prävention",
      "mental": "Seelisches Wohlbefinden",
      "hygiene": "Hygiene & Gewohnheiten",
      "searchPlaceholder": "Gesundheitsthemen suchen...",
      "popularTopics": "Beliebte Themen",
      "readMore": "Weiterlesen",
      "readTime": "Min. Lesezeit"
    },
    "reminders": {
      "title": "Familien-Erinnerungen",
      "subtitle": "Verpassen Sie keine Vorsorgetermine für Ihre Liebsten",
      "createReminder": "Erinnerung erstellen",
      "familyMember": "Familienmitglied",
      "reminderType": "Art der Erinnerung",
      "frequency": "Häufigkeit",
      "activeReminders": "Aktive Erinnerungen",
      "upcomingThisWeek": "Diese Woche anstehend",
      "noActiveReminders": "Keine aktiven Erinnerungen",
      "types": {
        "checkup": "Vorsorgeuntersuchung",
        "dental": "Zahnarztbesuch",
        "vision": "Sehtest",
        "vaccine": "Impfung",
        "medication": "Medikamenteneinnahme",
        "custom": "Individuell"
      }
    },
    "planner": {
      "title": "Familien-Gesundheitsplaner",
      "subtitle": "Koordinieren Sie die Vorsorge für Ihre Familie",
      "addMember": "Mitglied hinzufügen",
      "memberName": "Name",
      "relationship": "Verhältnis",
      "dateOfBirth": "Geburtsdatum",
      "viewCalendar": "Kalender anzeigen",
      "upcomingCare": "Anstehende Vorsorge",
      "nothingScheduled": "Noch keine Termine geplant",
      "scheduleCheckup": "Vorsorge planen",
      "relationships": {
        "child": "Kind",
        "spouse": "Partner/in",
        "parent": "Elternteil",
        "sibling": "Geschwister",
        "other": "Andere"
      }
    },
    "content": {
      "infantCare": {
        "title": "Vorsorge für Säuglinge",
        "intro": "Wichtige Tipps für das erste Lebensjahr Ihres Babys",
        "topics": [
          "Zeitplan der U-Untersuchungen",
          "Entwicklungsschritte im Blick",
          "Sicherer Schlaf",
          "Ernährung und Stillen",
          "Impfkalender"
        ]
      },
      "childDevelopment": {
        "title": "Kindliche Entwicklung",
        "intro": "Gesundes Wachstum verstehen",
        "topics": [
          "Körperliche Meilensteine",
          "Soziale und emotionale Reife",
          "Sprachentwicklung",
          "Kognitive Fähigkeiten",
          "Wann ärztlicher Rat sinnvoll ist"
        ]
      },
      "nutrition": {
        "title": "Ernährung & Wachstum",
        "intro": "Von Anfang an gesunde Essgewohnheiten fördern",
        "topics": [
          "Altersgerechte Ernährung",
          "Gesunde Snack-Ideen",
          "Umgang mit wählerischen Essern",
          "Grundlagen der Lebensmittelhygiene",
          "Trinkempfehlungen"
        ]
      },
      "safety": {
        "title": "Sicherheit & Unfallschutz",
        "intro": "Ein sicheres Umfeld für die Familie schaffen",
        "topics": [
          "Checkliste für ein sicheres Zuhause",
          "Kindersitze im Auto",
          "Sicherheit am Wasser",
          "Vergiftungsschutz",
          "Notfallvorsorge"
        ]
      }
    }
  }
};
